window.addNouvelleAquitaineMask = async function (map) {
  const T = window.turfFull || window.turf;
  if (!T) { console.error("Turf unavailable"); return; }

  if (!map.isStyleLoaded()) await new Promise(res => map.once("load", res));

  // ---------- 1) Load region ----------
  // Use local GeoJSON files instead of downloading from Etalab
  const themeGeoJsonPath = (window.themeGeoJson && window.themeGeoJson.baseUrl) 
    ? window.themeGeoJson.baseUrl 
    : "/wp-content/themes/hello-elementor-child/assets/geojson/";
  let regionNA;
  try {
    const r = await fetch(themeGeoJsonPath + "regions-1000m.geojson");
    const gj = await r.json();
    regionNA = gj.features.find(f => f.properties?.code === "75");
    if (!regionNA) throw new Error("Region not found");
  } catch (e) {
    console.error("Error loading regions:", e);
    return;
  }

  // ---------- 2) Create mask ----------
  const world = T.bboxPolygon([-180, -90, 180, 90]);
  const holes = [];

  if (regionNA.geometry.type === "Polygon") {
    holes.push(regionNA.geometry.coordinates[0]);
  } else if (regionNA.geometry.type === "MultiPolygon") {
    regionNA.geometry.coordinates.forEach(poly => holes.push(poly[0]));
  }

  const mask = {
    type: "Feature",
    properties: {},
    geometry: {
      type: "Polygon",
      coordinates: [
        world.geometry.coordinates[0],
        ...holes
      ]
    }
  };

  // ---------- 3) Add mask + outline ----------
  if (!map.getSource("mask")) {
    map.addSource("mask", { type: "geojson", data: mask });
    map.addLayer({
      id: "mask-layer",
      type: "fill",
      source: "mask",
      paint: { "fill-color": "#fff", "fill-opacity": 0.9 }
    });
  }

  if (!map.getSource("region-na")) {
    map.addSource("region-na", { type: "geojson", data: regionNA });
    map.addLayer({
      id: "region-outline",
      type: "line",
      source: "region-na",
      paint: { "line-color": "#007cba", "line-width": 2 }
    });
  }

  // ---------- 4) Load departments and communes ----------
  async function loadGeoData(url, regionCode = "75", regionFeature = regionNA) {
    const res = await fetch(url);
    const gj = await res.json();
    let feats = gj.features.filter(f => f.properties?.code_region === regionCode);
    if (!feats.length) {
      feats = gj.features.filter(f => T.booleanPointInPolygon(T.centroid(f), regionFeature));
    }
    return { type: "FeatureCollection", features: feats };
  }

  const deps = await loadGeoData(themeGeoJsonPath + "departements-1000m.geojson");
  const communes = await loadGeoData(themeGeoJsonPath + "communes-100m.geojson");

  // ---------- 5) Add sources and layers ----------
  if (!map.getSource("departements")) {
    map.addSource("departements", { type: "geojson", data: deps });
    map.addLayer({
      id: "deps-fill",
      type: "fill",
      source: "departements",
      layout: { visibility: "none" },
      paint: { "fill-color": "#f5b7b1", "fill-opacity": 0.3 }
    });
    map.addLayer({
      id: "deps-outline",
      type: "line",
      source: "departements",
      layout: { visibility: "none" },
      paint: { "line-color": "#900", "line-width": 1 }
    });
  }

  if (!map.getSource("communes")) {
    map.addSource("communes", { type: "geojson", data: communes });
    map.addLayer({
      id: "communes-fill",
      type: "fill",
      source: "communes",
      layout: { visibility: "none" },
      paint: { "fill-color": "#AED6F1", "fill-opacity": 0.25 }
    });
    map.addLayer({
      id: "communes-outline",
      type: "line",
      source: "communes",
      layout: { visibility: "none" },
      paint: { "line-color": "#1A5276", "line-width": 0.5 }
    });
  }

  // ---------- 6) Manage views ----------
  function setVisibility(id, visible) {
    if (map.getLayer(id)) map.setLayoutProperty(id, "visibility", visible ? "visible" : "none");
  }

  function setMode(mode) {
    if (!ui) return;
    const checkbox = ui.querySelector(`input[value="${mode}"]`);
    if (checkbox) {
      checkbox.checked = true;
      updateVisibility();
    }
  }

  window.naSetMode = setMode;

  let ui = null;
  let statusEl = null;

  // Function to create toggles in sidebar
  function createCheckboxesInSidebar(container) {
    if (container.querySelector('.ui-map-checkbox-list')) {
      ui = container.querySelector('.ui-map-checkbox-list');
      return;
    }

    const checkboxContainer = document.createElement("li");
    checkboxContainer.className = "ui-map-checkbox-list category-parent";
    checkboxContainer.innerHTML = `
      <div class="ui-map-logo">
        <img src="/wp-content/themes/hello-elementor-child/assets/images/agoralib-logo-vertical-bleu.svg" alt="AgoraLib">
      </div>
      <div class="ui-map-header">
        <h3>Niveaux géographiques</h3>
      </div>
      <div class="ui-map-checkboxes">
        <label class="toggle-label">
          <span class="toggle-text">Région</span>
          <input type="checkbox" id="geo-level-region" value="region" checked class="toggle-switch">
          <span class="toggle-slider"></span>
        </label>
        <label class="toggle-label">
          <span class="toggle-text">Départements</span>
          <input type="checkbox" id="geo-level-departements" value="departements" class="toggle-switch">
          <span class="toggle-slider"></span>
        </label>
        <label class="toggle-label">
          <span class="toggle-text">Communes</span>
          <input type="checkbox" id="geo-level-communes" value="communes" class="toggle-switch">
          <span class="toggle-slider"></span>
        </label>
      </div>
    `;

    const allElements = container.querySelectorAll('*');
    let targetUl = null;

    for (const el of allElements) {
      const text = el.textContent || el.innerText || '';
      if ((text.toLowerCase().includes('thématique') || text.toLowerCase().includes('population')) && el.tagName === 'LI') {
        let parent = el.parentElement;
        while (parent && parent.tagName !== 'UL') {
          parent = parent.parentElement;
        }
        if (parent && parent.tagName === 'UL') {
          targetUl = parent;
          break;
        }
      }
    }

    if (targetUl) {
      targetUl.insertBefore(checkboxContainer, targetUl.firstChild);
    } else {
      const firstUl = container.querySelector('ul');
      if (firstUl) {
        firstUl.insertBefore(checkboxContainer, firstUl.firstChild);
      } else {
        container.insertBefore(checkboxContainer, container.firstChild);
      }
    }

    ui = checkboxContainer;

    // Removed updateAllToggles function - now allows multiple selections
    // Each toggle can be independently checked/unchecked

    // Styles for labels and toggles
    const labels = checkboxContainer.querySelectorAll('.ui-map-checkboxes .toggle-label');
    labels.forEach(label => {

      const toggleText = label.querySelector('.toggle-text');
      const checkbox = label.querySelector('input.toggle-switch');
      const toggleSlider = label.querySelector('.toggle-slider');


      let updateToggleStyle = null;
      let toggleCheckbox = null;

      if (checkbox && toggleSlider) {
        Object.assign(checkbox.style, {
          opacity: "0",
          position: "absolute",
          width: "44px",
          height: "24px",
          margin: "0",
          padding: "0",
          cursor: "pointer",
          zIndex: "15",
          pointerEvents: "auto",
          right: "16px",
          top: "50%",
          transform: "translateY(-50%)"
        });

        Object.assign(toggleSlider.style, {
          position: "relative",
          display: "inline-block",
          width: "44px",
          height: "24px",
          backgroundColor: "#ccc",
          borderRadius: "24px",
          transition: "background-color 0.3s ease",
          cursor: "pointer",
          flexShrink: "0",
          order: "2",
          pointerEvents: "auto"
        });

        let toggleCircle = toggleSlider.querySelector('.toggle-circle');
        if (!toggleCircle) {
          toggleCircle = document.createElement('span');
          toggleCircle.className = 'toggle-circle';
          toggleSlider.appendChild(toggleCircle);
        }

        Object.assign(toggleCircle.style, {
          position: "absolute",
          height: "18px",
          width: "18px",
          left: "3px",
          top: "3px",
          backgroundColor: "white",
          borderRadius: "50%",
          transition: "transform 0.3s ease",
          boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
          pointerEvents: "none"
        });

        Object.assign(label.style, {
          position: "relative"
        });

        updateToggleStyle = function () {
          if (checkbox.checked) {
            toggleSlider.style.backgroundColor = "#01E37F";
            toggleCircle.style.transform = "translateX(20px)";
          } else {
            toggleSlider.style.backgroundColor = "#ccc";
            toggleCircle.style.transform = "translateX(0)";
          }
        };

        toggleCheckbox = function () {
          checkbox.checked = !checkbox.checked;
          updateToggleStyle();
          updateVisibility();
        };

        checkbox.addEventListener("change", (e) => {
          e.stopPropagation();
          updateToggleStyle();
          updateVisibility();
        });

        updateToggleStyle();

        toggleSlider.addEventListener("click", (e) => {
          e.stopPropagation();
          e.preventDefault();
          checkbox.checked = !checkbox.checked;
          const changeEvent = new Event('change', { bubbles: true });
          checkbox.dispatchEvent(changeEvent);
        });

        checkbox.addEventListener("click", (e) => {
          e.stopPropagation();
        });
      }

      if (label && checkbox && toggleCheckbox) {
        label.addEventListener("click", (e) => {
          e.stopPropagation();
          if (e.target !== checkbox && e.target !== toggleSlider &&
            !e.target.classList.contains('toggle-circle') &&
            (!toggleSlider || !toggleSlider.contains(e.target))) {
            toggleCheckbox();
          }
        });
      }
    });

    // Initialize all checked toggles (multiple can be checked)
    const allCheckboxes = checkboxContainer.querySelectorAll('input.toggle-switch');
    allCheckboxes.forEach(checkbox => {
      if (checkbox.checked) {
        const label = checkbox.closest('.toggle-label');
        const slider = label?.querySelector('.toggle-slider');
        const circle = slider?.querySelector('.toggle-circle');
        if (slider) {
          slider.style.backgroundColor = "#01E37F";
          if (circle) {
            circle.style.transform = "translateX(20px)";
          }
        }
      }
    });
    updateVisibility();
  }

  function updateVisibility() {
    if (!ui) return;
    const checkedModes = Array.from(ui.querySelectorAll('input[type="checkbox"]:checked')).map(cb => cb.value);

    const showRegion = checkedModes.includes("region");
    const showDeps = checkedModes.includes("departements");
    const showCom = checkedModes.includes("communes");

    // Update region outline visibility
    setVisibility("region-outline", showRegion);

    if (checkedModes.length === 0) {
      setVisibility("deps-fill", false);
      setVisibility("deps-outline", false);
      setVisibility("communes-fill", false);
      setVisibility("communes-outline", false);
    } else {
      setVisibility("deps-fill", showDeps);
      setVisibility("deps-outline", showDeps || showCom);
      setVisibility("communes-fill", showCom);
      setVisibility("communes-outline", showCom);
    }
  }

  // ---------- 8) Zoom initial ----------
  const bbox = T.bbox(regionNA);
  if (bbox && bbox.length === 4) {
    map.fitBounds([[bbox[0], bbox[1]], [bbox[2], bbox[3]]], { padding: 40, duration: 800 });
    
    // Set max bounds to cover France/Europe but allow horizontal scrolling
    // Use France's approximate bounds with generous padding for horizontal movement
    // France bounds: approximately [-5.0, 42.0] to [9.5, 51.0]
    map.setMaxBounds([
      [-6.0, 41.0], // Southwest corner (west of France, south of Pyrenees)
      [10.5, 52.0]  // Northeast corner (east of France, north of Belgium)
    ]);
  }

  map.setMinZoom(5); // Reduced from 6 to allow more zoom out

  // ---------- 8.5) Add outlines to CPTS polygons ----------
  function addCPTSOutlines() {
    const style = map.getStyle();
    if (!style || !style.layers) return;
    
    const ourSources = ['departements', 'communes', 'region-na', 'mask'];
    const outlineLayers = new Set();
    
    // Track existing outline layers to avoid duplicates
    style.layers.forEach(layer => {
      if (layer.id && layer.id.endsWith('-outline')) {
        outlineLayers.add(layer.id.replace('-outline', ''));
      }
    });
    
    style.layers.forEach(layer => {
      // Skip our own layers and existing outline layers
      if (ourSources.includes(layer.source) || outlineLayers.has(layer.id)) {
        return;
      }
      
      // Only process fill layers (CPTS polygons)
      if (layer.type === 'fill' && layer.source) {
        const source = map.getSource(layer.source);
        if (!source) return;
        
        const outlineLayerId = layer.id + '-outline';
        
        // Check if outline layer already exists
        if (map.getLayer(outlineLayerId)) {
          return;
        }
        
        try {
          // Create outline layer with same source and filter
          map.addLayer({
            id: outlineLayerId,
            type: 'line',
            source: layer.source,
            paint: {
              'line-color': '#333333', // Dark gray outline
              'line-width': 1.5,      // 1.5px width
              'line-opacity': 0.8      // Slightly transparent
            },
            layout: {
              visibility: layer.layout?.visibility || 'visible'
            }
          }, layer.id); // Insert after the fill layer
          
          // Copy the filter from fill layer to outline layer
          if (layer.filter) {
            try {
              map.setFilter(outlineLayerId, layer.filter);
            } catch (e) {
              console.warn(`Could not set filter for outline layer ${outlineLayerId}:`, e);
            }
          }
        } catch (e) {
          console.warn(`Could not add outline for layer ${layer.id}:`, e);
        }
      }
    });
  }
  
  // Call addCPTSOutlines when map style loads and after style changes
  if (map.isStyleLoaded()) {
    addCPTSOutlines();
  } else {
    map.once('styledata', () => {
      setTimeout(addCPTSOutlines, 100); // Small delay to ensure all layers are loaded
    });
  }
  
  // Also add outlines when new layers are added (Mapster might add layers dynamically)
  map.on('styledata', () => {
    setTimeout(addCPTSOutlines, 100);
  });

  // ---------- 8.6) Function to get all Mapster polygons from map ----------
  window.getMapsterPolygons = function () {
    const polygons = [];

    // Sources we created (to exclude)
    const ourSources = ['departements', 'communes', 'region-na', 'mask'];

    // Iterate through all map sources
    const style = map.getStyle();
    if (style && style.sources) {
      Object.keys(style.sources).forEach(sourceName => {
        if (ourSources.includes(sourceName)) {
          return;
        }

        const source = map.getSource(sourceName);
        if (source && source._data) {
          const data = source._data;
          if (data.type === 'FeatureCollection' && data.features) {
            data.features.forEach(feature => {
              if (feature.geometry && (
                feature.geometry.type === 'Polygon' ||
                feature.geometry.type === 'MultiPolygon'
              )) {
                polygons.push({
                  source: sourceName,
                  feature: feature,
                  properties: feature.properties || {},
                  geometry: feature.geometry,
                  id: feature.id || feature.properties?.id || null
                });
              }
            });
          }
        }
      });
    }

    try {
      const allFeatures = map.queryRenderedFeatures();
      allFeatures.forEach(feature => {
        if (feature.geometry && feature.layer &&
          (feature.geometry.type === 'Polygon' || feature.geometry.type === 'MultiPolygon')) {
          const alreadyAdded = polygons.some(p =>
            p.source === feature.source &&
            (p.id === feature.id ||
              JSON.stringify(p.geometry) === JSON.stringify(feature.geometry))
          );

          if (!alreadyAdded && !ourSources.includes(feature.source)) {
            polygons.push({
              source: feature.source,
              feature: feature,
              properties: feature.properties || {},
              geometry: feature.geometry,
              id: feature.id || null,
              layer: feature.layer?.id || null
            });
          }
        }
      });
    } catch (e) {
      console.warn('Error retrieving via queryRenderedFeatures:', e);
    }

    return polygons;
  };

  window.createCPTSFilters = async function () {
    const polygons = window.getMapsterPolygons();
    const cptsSet = new Set();
    const cptsMap = new Map();
    const postIds = new Set();

    polygons.forEach((polygon) => {
      const props = polygon.properties || {};
      const feature = polygon.feature;

      let cptName = null;
      let postId = null;

      if (props.post_id) {
        postId = parseInt(props.post_id);
      } else if (props.id) {
        postId = parseInt(props.id);
      } else if (props.feature_id) {
        postId = parseInt(props.feature_id);
      } else if (feature?.properties?.post_id) {
        postId = parseInt(feature.properties.post_id);
      } else if (feature?.properties?.id) {
        postId = parseInt(feature.properties.id);
      }

      if (props.name && String(props.name).trim()) {
        cptName = String(props.name).trim();
      } else if (props.title && String(props.title).trim()) {
        cptName = String(props.title).trim();
      } else if (props.label && String(props.label).trim()) {
        cptName = String(props.label).trim();
      } else if (feature?.properties?.name && String(feature.properties.name).trim()) {
        cptName = String(feature.properties.name).trim();
      } else if (feature?.properties?.title && String(feature.properties.title).trim()) {
        cptName = String(feature.properties.title).trim();
      } else if (props.additional_details_CPTS) {
        const additionalDetails = props.additional_details_CPTS;
        if (Array.isArray(additionalDetails)) {
          additionalDetails.forEach(cpt => {
            if (cpt && String(cpt).trim()) {
              const cptValue = String(cpt).trim();
              cptsSet.add(cptValue);
              if (!cptsMap.has(cptValue)) {
                cptsMap.set(cptValue, []);
              }
              cptsMap.get(cptValue).push(polygon);
            }
          });
        } else if (typeof additionalDetails === 'string') {
          cptName = additionalDetails.trim();
        }
      } else if (props.additional_details?.CPTS) {
        const additionalDetails = props.additional_details.CPTS;
        if (Array.isArray(additionalDetails)) {
          additionalDetails.forEach(cpt => {
            if (cpt && String(cpt).trim()) {
              const cptValue = String(cpt).trim();
              cptsSet.add(cptValue);
              if (!cptsMap.has(cptValue)) {
                cptsMap.set(cptValue, []);
              }
              cptsMap.get(cptValue).push(polygon);
            }
          });
        } else if (typeof additionalDetails === 'string') {
          cptName = additionalDetails.trim();
        }
      }

      if (cptName) {
        cptsSet.add(cptName);
        if (!cptsMap.has(cptName)) {
          cptsMap.set(cptName, []);
        }
        cptsMap.get(cptName).push(polygon);
      } else if (postId) {
        postIds.add(postId);
        polygon._postId = postId;
      }
    });

    if (postIds.size > 0) {
      try {
        const postIdsArray = Array.from(postIds);
        const ajaxUrl = window.ajaxurl || (window.location.origin + '/wp-admin/admin-ajax.php');

        const response = await fetch(ajaxUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: new URLSearchParams({
            action: 'get_cpts_names',
            post_ids: JSON.stringify(postIdsArray)
          })
        });

        if (response.ok) {
          const data = await response.json();
          const names = data.data?.names || data.names || {};

          if (data.success && names && Object.keys(names).length > 0) {
            polygons.forEach(polygon => {
              if (polygon._postId && names[polygon._postId]) {
                const cptName = String(names[polygon._postId]).trim();
                if (cptName) {
                  cptsSet.add(cptName);
                  if (!cptsMap.has(cptName)) {
                    cptsMap.set(cptName, []);
                  }
                  cptsMap.get(cptName).push(polygon);
                }
              }
            });
          }
        }
      } catch (error) {
        console.error('Error retrieving titles:', error);
      }
    }

    const filtersList = Array.from(cptsSet).sort();

    const result = {
      filters: filtersList,
      count: filtersList.length,
      polygonsByCPTS: Object.fromEntries(cptsMap),
      totalPolygons: polygons.length
    };

    return result;
  };

  async function createCPTSFiltersInSidebar() {
    if (window._creatingCPTSFilters) {
      return;
    }

    window._creatingCPTSFilters = true;
    const bottomLeftCtrl = document.querySelector('.mapboxgl-ctrl-bottom-left');

    if (!bottomLeftCtrl) {
      window._creatingCPTSFilters = false;
      return;
    }

    let cptsContainer = bottomLeftCtrl.querySelector('.cpts-filters-container');

    if (cptsContainer) {
      window._creatingCPTSFilters = false;
      return;
    }

    if (typeof window.createCPTSFilters !== 'function') {
      window._creatingCPTSFilters = false;
      return;
    }

    const filtersData = await window.createCPTSFilters();

    if (!filtersData || !filtersData.filters || filtersData.filters.length === 0) {
      window._creatingCPTSFilters = false;
      return;
    }

    cptsContainer = document.createElement("li");
    cptsContainer.className = "cpts-filters-container category-parent mapster-accordion-indicator-closed";
    cptsContainer._filtersData = filtersData;

    const accordionHeader = document.createElement('div');
    accordionHeader.className = 'mapster-accordion-indicator-closed';
    accordionHeader.style.display = 'flex';
    accordionHeader.style.alignItems = 'center';
    accordionHeader.style.justifyContent = 'space-between';
    accordionHeader.style.gap = '0';
    accordionHeader.style.flexWrap = 'wrap';

    // Checkbox to select/deselect all
    const selectAllCheckbox = document.createElement('input');
    selectAllCheckbox.type = 'checkbox';
    selectAllCheckbox.id = 'cpts-select-all-checkbox';
    selectAllCheckbox.className = 'cpts-select-all-checkbox';
    selectAllCheckbox.checked = false; // By default, none are selected
    selectAllCheckbox.style.cssText = 'flex-shrink: 0; margin-right: 0; cursor: pointer;';
    
    // Handle click on "Select all/deselect all" checkbox
    selectAllCheckbox.addEventListener('change', (e) => {
      e.stopPropagation();
      const checkboxes = cptsContainer.querySelectorAll('.cpts-filter-checkbox');
      const isChecked = selectAllCheckbox.checked;
      checkboxes.forEach(checkbox => {
        checkbox.checked = isChecked;
      });
      updateCPTSFiltersVisibility();
    });

    const headerLabel = document.createElement('span');
    headerLabel.textContent = 'CPTS';
    headerLabel.style.cssText = 'margin: 0; cursor: pointer; flex: 1;';

    // Container for checkbox + label
    const checkboxLabelContainer = document.createElement('div');
    checkboxLabelContainer.style.cssText = 'display: flex; align-items: center; gap: 8px; flex: 1;';
    checkboxLabelContainer.appendChild(selectAllCheckbox);
    checkboxLabelContainer.appendChild(headerLabel);

    const accordionIndicator = document.createElement('span');
    accordionIndicator.className = 'mapster-accordion-indicator';
    accordionIndicator.style.cssText = 'flex: 0 0 auto; flex-shrink: 0;';

    // Function to update "Select all" checkbox state
    function updateSelectAllCheckboxState() {
      setTimeout(() => {
        const checkboxes = cptsContainer.querySelectorAll('.cpts-filter-checkbox');
        const checkedCount = cptsContainer.querySelectorAll('.cpts-filter-checkbox:checked').length;
        const totalCount = checkboxes.length;
        
        if (totalCount === 0) {
          selectAllCheckbox.checked = false;
          selectAllCheckbox.indeterminate = false;
        } else if (checkedCount === totalCount) {
          // All are selected
          selectAllCheckbox.checked = true;
          selectAllCheckbox.indeterminate = false;
        } else if (checkedCount === 0) {
          // None are selected
          selectAllCheckbox.checked = false;
          selectAllCheckbox.indeterminate = false;
        } else {
          // Mixed state: checkbox in indeterminate state
          selectAllCheckbox.checked = false;
          selectAllCheckbox.indeterminate = true;
        }
      }, 0);
    }

    // Add elements to header in correct order
    accordionHeader.appendChild(checkboxLabelContainer);
    accordionHeader.appendChild(accordionIndicator);


    const filtersListDiv = document.createElement('div');
    filtersListDiv.className = 'cpts-filters-list';

    filtersData.filters.forEach((cpt, index) => {
      const checkboxId = `cpts-filter-${index}`;

      const label = document.createElement('label');
      label.innerHTML = `
        <input type="checkbox" id="${checkboxId}" value="${cpt}" class="cpts-filter-checkbox">
        <span>${cpt}</span>
      `;

      filtersListDiv.appendChild(label);
    });

    cptsContainer.appendChild(accordionHeader);
    cptsContainer.appendChild(filtersListDiv);

    accordionHeader.addEventListener('click', (e) => {
      // Don't handle click if it's on "Select all" checkbox or filter list items
      // Allow clicks on the title (span) to toggle accordion
      if (e.target === selectAllCheckbox || selectAllCheckbox.contains(e.target) ||
          filtersListDiv.contains(e.target)) {
        return;
      }
      e.stopPropagation();
      const isOpen = accordionHeader.className.includes('open');

      if (isOpen) {
        filtersListDiv.style.maxHeight = '0';
        filtersListDiv.classList.remove('is-open');
        setTimeout(() => {
          if (!filtersListDiv.classList.contains('is-open')) {
            filtersListDiv.style.display = 'none';
          }
        }, 300);
        accordionHeader.className = 'mapster-accordion-indicator-closed';
        cptsContainer.className = 'cpts-filters-container category-parent mapster-accordion-indicator-closed';
      } else {
        filtersListDiv.style.display = 'flex';
        filtersListDiv.classList.add('is-open');
        setTimeout(() => {
          const scrollHeight = filtersListDiv.scrollHeight;
          filtersListDiv.style.maxHeight = scrollHeight + 'px';
        }, 10);
        accordionHeader.className = 'mapster-accordion-indicator-open';
        cptsContainer.className = 'cpts-filters-container category-parent mapster-accordion-indicator-open';
      }
    });

    const labels = filtersListDiv.querySelectorAll('label');
    labels.forEach(label => {
      const checkbox = label.querySelector('input.cpts-filter-checkbox');
      const span = label.querySelector('span');

      if (checkbox) {
        // Ensure label is associated with checkbox via 'for' attribute
        if (!label.hasAttribute('for') && checkbox.id) {
          label.setAttribute('for', checkbox.id);
        }

        checkbox.addEventListener('change', (e) => {
          e.stopPropagation();
          updateCPTSFiltersVisibility();
          updateSelectAllCheckboxState();
        });

        // Don't prevent default checkbox behavior
        checkbox.addEventListener('click', (e) => {
          // Let default behavior work
          // Label will handle click if needed
        });
      }

      // Handle click on label or span to toggle checkbox
      // Native label behavior should work, but we make sure it does
      label.addEventListener('click', (e) => {
        // If clicking directly on checkbox, let default behavior work
        if (e.target === checkbox) {
          return;
        }
        
        // If clicking on label or span, toggle checkbox manually
        if (checkbox && (e.target === label || e.target === span || label.contains(e.target))) {
          // Don't prevent default if it's the label containing the checkbox
          // But ensure change is triggered
          if (e.target !== checkbox) {
            e.preventDefault();
          checkbox.checked = !checkbox.checked;
          const changeEvent = new Event('change', { bubbles: false });
          checkbox.dispatchEvent(changeEvent);
        }
        }
      });

      // Ensure label is clickable with pointer cursor
      label.style.cursor = 'pointer';
      if (span) {
        span.style.cursor = 'pointer';
        span.style.userSelect = 'none';
      }
    });

    updateSelectAllCheckboxState();
    
    // Expose function so it's accessible from outside
    cptsContainer._updateSelectAllCheckboxState = updateSelectAllCheckboxState;

    function updateCPTSFiltersVisibility() {
      // Call unified filtering function
      if (typeof window.updateAllFilters === 'function') {
        window.updateAllFilters();
      }
    }

    cptsContainer._updateCPTSFiltersVisibility = updateCPTSFiltersVisibility;

    const allElements = Array.from(bottomLeftCtrl.querySelectorAll('*'));
    let targetUl = null;
    let insertAfter = null;

    for (const el of allElements) {
      const text = el.textContent || el.innerText || '';
      if (text.toLowerCase().includes('niveaux géographiques') &&
        (el.tagName === 'H3' || el.closest('.ui-map-checkbox-list'))) {
        const parentLi = el.closest('li') || el.parentElement.closest('li');
        if (parentLi && parentLi.parentElement) {
          targetUl = parentLi.parentElement;
          insertAfter = parentLi;
          break;
        }
      }
    }

    if (targetUl && insertAfter && insertAfter.nextSibling) {
      targetUl.insertBefore(cptsContainer, insertAfter.nextSibling);
    } else if (targetUl && insertAfter) {
      targetUl.appendChild(cptsContainer);
    } else {
      const firstUl = bottomLeftCtrl.querySelector('ul');
      if (firstUl) {
        firstUl.insertBefore(cptsContainer, firstUl.firstChild);
      } else {
        bottomLeftCtrl.insertBefore(cptsContainer, bottomLeftCtrl.firstChild);
      }
    }

    window._creatingCPTSFilters = false;
    
    // Check if sidebar should be shown now
    setTimeout(() => {
      showSidebarWhenReady();
    }, 100);
  }

  window.createCPTSFiltersInSidebar = createCPTSFiltersInSidebar;

  // ---------- Unified function to combine all filters (CPTS + Themes + Populations) ----------
  function updateAllFilters() {
    const bottomLeftCtrl = document.querySelector('.mapboxgl-ctrl-bottom-left');
    if (!bottomLeftCtrl) return;

    // Get CPTS filters
    const cptsContainer = bottomLeftCtrl.querySelector('.cpts-filters-container');
    const selectedCPTS = cptsContainer
      ? Array.from(cptsContainer.querySelectorAll('.cpts-filter-checkbox:checked'))
          .map(cb => cb.value)
      : [];
    const polygonsByCPTS = cptsContainer?._filtersData?.polygonsByCPTS || {};

    // Get Themes/Populations filters
    const thematiquesContainer = bottomLeftCtrl.querySelector('.thematiques-filters-container');
    const populationsContainer = bottomLeftCtrl.querySelector('.populations-filters-container');
    const selectedThematiques = thematiquesContainer 
      ? Array.from(thematiquesContainer.querySelectorAll('.thematique-filter-checkbox:checked'))
          .map(cb => cb.value)
      : [];
    const selectedPopulations = populationsContainer
      ? Array.from(populationsContainer.querySelectorAll('.population-filter-checkbox:checked'))
          .map(cb => cb.value)
      : [];
    const postIdToPairs = thematiquesContainer?._postIdToPairs || populationsContainer?._postIdToPairs || new Map();

    // Check if filter containers exist (to know if filters are available)
    const hasCPTSFilters = cptsContainer && cptsContainer.querySelectorAll('.cpts-filter-checkbox').length > 0;
    const hasThematiquesFilters = thematiquesContainer && thematiquesContainer.querySelectorAll('.thematique-filter-checkbox').length > 0;
    const hasPopulationsFilters = populationsContainer && populationsContainer.querySelectorAll('.population-filter-checkbox').length > 0;

    // If all filters are deselected, show all polygons (default behavior)
    if ((hasCPTSFilters && selectedCPTS.length === 0) &&
        (hasThematiquesFilters && selectedThematiques.length === 0) &&
        (hasPopulationsFilters && selectedPopulations.length === 0)) {
      const style = map.getStyle();
      if (style && style.layers) {
        const ourSources = ['departements', 'communes', 'region-na', 'mask'];
        style.layers.forEach(layer => {
          if (!ourSources.includes(layer.source) &&
            (layer.type === 'fill' || layer.type === 'line')) {
            // Skip outline layers - they will be handled with their corresponding fill layer
            if (layer.id && layer.id.endsWith('-outline')) {
              return;
            }
            
            try {
              map.setLayoutProperty(layer.id, 'visibility', 'visible');
              // Reset filter to show all
              const originalFilter = window._mapsterOriginalFilters?.get(layer.id);
              if (originalFilter !== null && originalFilter !== undefined) {
                map.setFilter(layer.id, originalFilter);
              } else {
                map.setFilter(layer.id, null);
              }
              
              // Sync outline layer
              const outlineLayerId = layer.id + '-outline';
              if (map.getLayer(outlineLayerId)) {
                map.setLayoutProperty(outlineLayerId, 'visibility', 'visible');
                if (originalFilter !== null && originalFilter !== undefined) {
                  map.setFilter(outlineLayerId, originalFilter);
                } else {
                  map.setFilter(outlineLayerId, null);
                }
              }
            } catch (e) {
              console.warn('Error showing all polygons:', e);
            }
          }
        });
      }
      return;
    }

    // Collect polygon IDs matching CPTS filters
    const cptsPolygonIds = new Set();
    selectedCPTS.forEach(cptName => {
      const polygonsForCPTS = polygonsByCPTS[cptName] || [];
      polygonsForCPTS.forEach(polygon => {
        if (polygon.id !== null && polygon.id !== undefined) {
          cptsPolygonIds.add(polygon.id);
        }
        if (polygon.feature?.id !== null && polygon.feature?.id !== undefined) {
          cptsPolygonIds.add(polygon.feature.id);
        }
        if (polygon.properties?.id) {
          cptsPolygonIds.add(polygon.properties.id);
        }
      });
    });

    // Collect post_ids matching Themes/Populations filters
    const themePopPostIds = new Set();
    if (selectedThematiques.length > 0 || selectedPopulations.length > 0) {
      postIdToPairs.forEach((pairs, postId) => {
        let matchesTheme = selectedThematiques.length === 0;
        let matchesPopulation = selectedPopulations.length === 0;

        pairs.forEach(pair => {
          if (selectedThematiques.length > 0 && selectedThematiques.includes(pair.theme)) {
            matchesTheme = true;
          }
          if (selectedPopulations.length > 0 && selectedPopulations.includes(pair.population)) {
            matchesPopulation = true;
          }
        });

        if (matchesTheme && matchesPopulation) {
          themePopPostIds.add(postId);
        }
      });
    }

    // Combine filters: a polygon must match CPTS filters AND Themes/Populations filters
    const finalPolygonIds = new Set();
    const finalPostIds = new Set();

    // If CPTS filters are selected, use corresponding polygon IDs
    if (selectedCPTS.length > 0 && cptsPolygonIds.size > 0) {
      cptsPolygonIds.forEach(id => finalPolygonIds.add(id));
    }

    // If Themes/Populations filters are selected, use corresponding post_ids
    if ((selectedThematiques.length > 0 || selectedPopulations.length > 0) && themePopPostIds.size > 0) {
      themePopPostIds.forEach(postId => finalPostIds.add(postId));
    }

    // If both filter types are active, combine results
    const selectedPolygonIds = finalPolygonIds;
    
    // If we have CPTS filters AND Themes/Populations filters, 
    // we must find the intersection (polygons that match both)
    if (selectedCPTS.length > 0 && (selectedThematiques.length > 0 || selectedPopulations.length > 0)) {
      // Get post_ids of selected CPTS polygons
      const cptsPostIds = new Set();
      const polygons = window.getMapsterPolygons();
      polygons.forEach(polygon => {
        if (selectedPolygonIds.has(polygon.id) || 
            selectedPolygonIds.has(polygon.feature?.id) ||
            selectedPolygonIds.has(polygon.properties?.id)) {
          const props = polygon.properties || {};
          const featureProps = polygon.feature?.properties || {};
          const postId = parseInt(props.post_id || props.id || props.feature_id || 
                               featureProps.post_id || featureProps.id || 0);
          if (postId > 0) {
            cptsPostIds.add(postId);
          }
        }
      });
      
      // Intersection: keep only post_ids that are in both sets
      const intersectionPostIds = new Set();
      cptsPostIds.forEach(postId => {
        if (themePopPostIds.has(postId)) {
          intersectionPostIds.add(postId);
        }
      });
      
      // If intersection is empty, hide all polygons
      if (intersectionPostIds.size === 0) {
        const style = map.getStyle();
        if (style && style.layers) {
          const ourSources = ['departements', 'communes', 'region-na', 'mask'];
          style.layers.forEach(layer => {
            if (!ourSources.includes(layer.source) &&
              (layer.type === 'fill' || layer.type === 'line')) {
              map.setLayoutProperty(layer.id, 'visibility', 'none');
            }
          });
        }
        return;
      }
      
      // Use intersection for filtering
      finalPostIds.clear();
      intersectionPostIds.forEach(postId => finalPostIds.add(postId));
      selectedPolygonIds.clear(); // Reset because we'll use post_ids
    } else if (selectedCPTS.length === 0 && (selectedThematiques.length > 0 || selectedPopulations.length > 0)) {
      // Only Themes/Populations filters: use post_ids
      selectedPolygonIds.clear();
    } else if (selectedCPTS.length > 0 && selectedThematiques.length === 0 && selectedPopulations.length === 0) {
      // Only CPTS filters: use polygon IDs
      finalPostIds.clear();
    }

    if (!window._mapsterOriginalFilters) {
      window._mapsterOriginalFilters = new Map();
      const style = map.getStyle();
      if (style && style.layers) {
        const ourSources = ['departements', 'communes', 'region-na', 'mask'];
        style.layers.forEach(layer => {
          if (ourSources.includes(layer.source)) {
            return;
          }

          if (layer.type === 'fill' || layer.type === 'line') {
            const currentFilter = map.getFilter(layer.id);
            window._mapsterOriginalFilters.set(layer.id,
              currentFilter !== null && currentFilter !== undefined
                ? JSON.parse(JSON.stringify(currentFilter))
                : null
            );
          }
        });
      }
    }

    const style = map.getStyle();
    if (style && style.layers) {
      const ourSources = ['departements', 'communes', 'region-na', 'mask'];

      style.layers.forEach(layer => {
        if (ourSources.includes(layer.source)) {
          return;
        }

        if (layer.type === 'fill' || layer.type === 'line') {
          // Skip outline layers - they will be handled with their corresponding fill layer
          if (layer.id && layer.id.endsWith('-outline')) {
            return;
          }
          
          try {
            const originalFilter = window._mapsterOriginalFilters.get(layer.id) || null;
            const outlineLayerId = layer.id + '-outline';
            const hasOutlineLayer = map.getLayer(outlineLayerId) !== undefined;

            // Check if all filters are selected (default state)
            const allCPTSCheckboxes = cptsContainer?.querySelectorAll('.cpts-filter-checkbox') || [];
            const totalCPTSCheckboxes = allCPTSCheckboxes.length;
            const checkedCPTSCheckboxes = cptsContainer?.querySelectorAll('.cpts-filter-checkbox:checked').length || 0;
            
            const allThemeCheckboxes = thematiquesContainer?.querySelectorAll('.thematique-filter-checkbox') || [];
            const totalThemeCheckboxes = allThemeCheckboxes.length;
            const checkedThemeCheckboxes = thematiquesContainer?.querySelectorAll('.thematique-filter-checkbox:checked').length || 0;
            
            const allPopCheckboxes = populationsContainer?.querySelectorAll('.population-filter-checkbox') || [];
            const totalPopCheckboxes = allPopCheckboxes.length;
            const checkedPopCheckboxes = populationsContainer?.querySelectorAll('.population-filter-checkbox:checked').length || 0;

            const allFiltersSelected = 
              (totalCPTSCheckboxes === 0 || checkedCPTSCheckboxes === totalCPTSCheckboxes) &&
              (totalThemeCheckboxes === 0 || checkedThemeCheckboxes === totalThemeCheckboxes) &&
              (totalPopCheckboxes === 0 || checkedPopCheckboxes === totalPopCheckboxes);

            if (allFiltersSelected && (totalCPTSCheckboxes > 0 || totalThemeCheckboxes > 0 || totalPopCheckboxes > 0)) {
              // All filters are selected: show all polygons
              try {
                map.setLayoutProperty(layer.id, 'visibility', 'visible');
                if (originalFilter && originalFilter !== null) {
                  const restoredFilter = JSON.parse(JSON.stringify(originalFilter));
                  map.setFilter(layer.id, restoredFilter);
                  // Sync outline layer
                  if (hasOutlineLayer) {
                    map.setLayoutProperty(outlineLayerId, 'visibility', 'visible');
                    map.setFilter(outlineLayerId, restoredFilter);
                  }
                } else {
                  map.setFilter(layer.id, null);
                  // Sync outline layer
                  if (hasOutlineLayer) {
                    map.setLayoutProperty(outlineLayerId, 'visibility', 'visible');
                    map.setFilter(outlineLayerId, null);
                  }
                }
              } catch (e) {
                map.setLayoutProperty(layer.id, 'visibility', 'visible');
                map.setFilter(layer.id, null);
                // Sync outline layer
                if (hasOutlineLayer) {
                  try {
                    map.setLayoutProperty(outlineLayerId, 'visibility', 'visible');
                    map.setFilter(outlineLayerId, null);
                  } catch (e2) {
                    // Ignore outline errors
                  }
                }
              }
            } else {
              // Apply combined filters
              map.setLayoutProperty(layer.id, 'visibility', 'visible');
              // Sync outline layer visibility
              if (hasOutlineLayer) {
                map.setLayoutProperty(outlineLayerId, 'visibility', 'visible');
              }

              let filterExpr = null;

              // If we have post_ids (Themes/Populations filters or combination)
              if (finalPostIds.size > 0) {
                const source = map.getSource(layer.source);
                if (source && source._data && source._data.features) {
                  const features = source._data.features;
                  const matchingFeatureIds = new Set();

                  features.forEach(feature => {
                    const props = feature.properties || {};
                    const postId = parseInt(props.post_id || props.id || props.feature_id || 0);
                    if (postId > 0 && finalPostIds.has(postId)) {
                      if (feature.id !== null && feature.id !== undefined) {
                        matchingFeatureIds.add(feature.id);
                      }
                    }
                  });

                  if (matchingFeatureIds.size > 0) {
                    filterExpr = ['in', ['id'], ['literal', Array.from(matchingFeatureIds)]];
                  } else {
                    // Fallback: use post_id filter in properties
                    const filterConditions = [];
                    finalPostIds.forEach(postId => {
                      filterConditions.push(['==', ['get', 'post_id'], postId]);
                      filterConditions.push(['==', ['get', 'id'], postId]);
                    });
                    if (filterConditions.length > 0) {
                      filterExpr = ['any', ...filterConditions];
                    }
                  }
                } else {
                  // Fallback: use post_id filter in properties
                  const filterConditions = [];
                  finalPostIds.forEach(postId => {
                    filterConditions.push(['==', ['get', 'post_id'], postId]);
                    filterConditions.push(['==', ['get', 'id'], postId]);
                  });
                  if (filterConditions.length > 0) {
                    filterExpr = ['any', ...filterConditions];
                  }
                }
              } else if (selectedPolygonIds.size > 0) {
                // Use polygon IDs (CPTS filters only)
                const polygonIdArray = Array.from(selectedPolygonIds);
                filterExpr = ['in', ['id'], ['literal', polygonIdArray]];
              } else if (selectedCPTS.length > 0) {
                // Fallback: use CPTS names
                const filterConditions = [];
                selectedCPTS.forEach(cpt => {
                  filterConditions.push(
                    ['==', ['get', 'additional_details_CPTS'], cpt],
                    ['==', ['get', 'name'], cpt],
                    ['==', ['get', 'title'], cpt],
                    ['==', ['get', 'label'], cpt]
                  );

                  if (polygonsByCPTS[cpt]) {
                    const cptPolygons = polygonsByCPTS[cpt];
                    cptPolygons.forEach(p => {
                      if (p.id !== null && p.id !== undefined) {
                        filterConditions.push(['==', ['id'], p.id]);
                      }
                      if (p.feature?.id !== null && p.feature?.id !== undefined) {
                        filterConditions.push(['==', ['id'], p.feature.id]);
                      }
                      if (p.properties?.id) {
                        filterConditions.push(['==', ['id'], p.properties.id]);
                      }
                    });
                  }
                });
                filterExpr = ['any', ...filterConditions];
              }

              if (filterExpr) {
                if (originalFilter && originalFilter !== null) {
                  filterExpr = ['all', originalFilter, filterExpr];
                }
                try {
                  map.setFilter(layer.id, filterExpr);
                  // Sync outline layer filter
                  if (hasOutlineLayer) {
                    map.setFilter(outlineLayerId, filterExpr);
                  }
                } catch (e) {
                  map.setLayoutProperty(layer.id, 'visibility', 'visible');
                  // Sync outline layer
                  if (hasOutlineLayer) {
                    try {
                      map.setLayoutProperty(outlineLayerId, 'visibility', 'visible');
                    } catch (e2) {
                      // Ignore outline errors
                    }
                  }
                }
              } else {
                map.setFilter(layer.id, ['==', ['literal', false], true]);
                // Sync outline layer filter
                if (hasOutlineLayer) {
                  map.setFilter(outlineLayerId, ['==', ['literal', false], true]);
                }
              }
            }
          } catch (e) {
            console.warn('Error during filtering:', e);
            map.setLayoutProperty(layer.id, 'visibility', 'none');
            // Hide outline layer on error
            const outlineLayerId = layer.id + '-outline';
            if (map.getLayer(outlineLayerId)) {
              try {
                map.setLayoutProperty(outlineLayerId, 'visibility', 'none');
              } catch (e2) {
                // Ignore outline errors
              }
            }
          }
        }
      });
    }
  }
  
  window.updateAllFilters = updateAllFilters;

  // ---------- Function to create Themes and Populations filters ----------
  let _createThemePopulationFiltersRunning = false;
  
  async function createThemePopulationFilters() {
    // Prevent infinite loop
    if (_createThemePopulationFiltersRunning) {
      return;
    }
    
    const bottomLeftCtrl = document.querySelector('.mapboxgl-ctrl-bottom-left');
    if (!bottomLeftCtrl) {
      return;
    }

    // Check if filters already exist (on both mobile and desktop)
    const hasThematiques = bottomLeftCtrl.querySelector('.thematiques-filters-container');
    const hasPopulations = bottomLeftCtrl.querySelector('.populations-filters-container');
    if (hasThematiques || hasPopulations) {
      return;
    }
    
    _createThemePopulationFiltersRunning = true;

    try {
      // Get all polygons
      const polygons = window.getMapsterPolygons();
      if (!polygons || polygons.length === 0) {
        return;
      }

      // Get all post_ids
      const postIds = new Set();
      polygons.forEach(polygon => {
        const props = polygon.properties || {};
        const featureProps = polygon.feature?.properties || {};
        let postId = props.post_id || props.id || props.feature_id || 
                     featureProps.post_id || featureProps.id;
        if (postId) {
          postId = parseInt(postId);
          if (postId > 0) {
            postIds.add(postId);
          }
        }
      });

      if (postIds.size === 0) {
        return;
      }

      // Get custom properties from WordPress
      const ajaxUrl = window.ajaxurl || (window.location.origin + '/wp-admin/admin-ajax.php');
      const response = await fetch(ajaxUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          action: 'get_polygon_custom_properties',
          post_ids: JSON.stringify(Array.from(postIds))
        })
      });

      if (!response.ok) {
        return;
      }

      const data = await response.json();
      if (!data.success || !data.data?.custom_properties) {
        return;
      }

      // Collect all unique themes and populations
      const thematiquesSet = new Set();
      const populationsSet = new Set();
      const postIdToPairs = new Map(); // post_id -> [{theme, population, index}]

      Object.keys(data.data.custom_properties).forEach(postId => {
        const pairs = data.data.custom_properties[postId];
        if (pairs && pairs.length > 0) {
          postIdToPairs.set(parseInt(postId), pairs);
          pairs.forEach(pair => {
            if (pair.theme) {
              thematiquesSet.add(pair.theme);
            }
            if (pair.population) {
              populationsSet.add(pair.population);
            }
          });
        }
      });

      // Create Thematics filters
      if (thematiquesSet.size > 0) {
        const thematiquesContainer = document.createElement('li');
        thematiquesContainer.className = 'thematiques-filters-container category-parent mapster-accordion-indicator-closed';

        const thematiquesHeader = document.createElement('div');
        thematiquesHeader.className = 'mapster-accordion-indicator-closed';
        thematiquesHeader.style.cssText = 'display: flex; align-items: center; justify-content: space-between; padding: 12px 16px; cursor: pointer; gap: 0; flex-wrap: wrap;';

        // Checkbox to select/deselect all
        const selectAllThematiquesCheckbox = document.createElement('input');
        selectAllThematiquesCheckbox.type = 'checkbox';
        selectAllThematiquesCheckbox.id = 'thematiques-select-all-checkbox';
        selectAllThematiquesCheckbox.className = 'thematiques-select-all-checkbox';
        selectAllThematiquesCheckbox.checked = false; // By default, nothing is selected
        selectAllThematiquesCheckbox.style.cssText = 'flex-shrink: 0; margin-right: 0; cursor: pointer;';

        // Handle click on "Select all/deselect all" checkbox
        selectAllThematiquesCheckbox.addEventListener('change', (e) => {
          e.stopPropagation();
          const checkboxes = thematiquesContainer.querySelectorAll('.thematique-filter-checkbox');
          const isChecked = selectAllThematiquesCheckbox.checked;
          checkboxes.forEach(checkbox => {
            checkbox.checked = isChecked;
          });
          updateThemePopulationFilters();
          updateThematiquesSelectAllCheckboxState();
        });

        const thematiquesLabel = document.createElement('span');
        thematiquesLabel.textContent = 'Thématiques';
        thematiquesLabel.style.cssText = 'margin: 0; cursor: pointer; flex: 1;';

        // Container for checkbox + label
        const checkboxLabelContainer = document.createElement('div');
        checkboxLabelContainer.style.cssText = 'display: flex; align-items: center; gap: 8px; flex: 1;';
        checkboxLabelContainer.appendChild(selectAllThematiquesCheckbox);
        checkboxLabelContainer.appendChild(thematiquesLabel);

        const thematiquesIndicator = document.createElement('span');
        thematiquesIndicator.className = 'mapster-accordion-indicator';
        thematiquesIndicator.style.cssText = 'flex: 0 0 auto; flex-shrink: 0;';

        thematiquesHeader.appendChild(checkboxLabelContainer);
        thematiquesHeader.appendChild(thematiquesIndicator);

        const thematiquesList = document.createElement('div');
        thematiquesList.className = 'thematiques-filters-list';

        const sortedThematiques = Array.from(thematiquesSet).sort();
        sortedThematiques.forEach((thematique, index) => {
          const checkboxId = `thematique-filter-${index}`;
          const label = document.createElement('label');
          label.innerHTML = `
            <input type="checkbox" id="${checkboxId}" value="${thematique}" class="thematique-filter-checkbox">
            <span>${thematique}</span>
          `;
          thematiquesList.appendChild(label);
        });

        // Function to update "Select all" checkbox state
        function updateThematiquesSelectAllCheckboxState() {
          setTimeout(() => {
            const checkboxes = thematiquesContainer.querySelectorAll('.thematique-filter-checkbox');
            const checkedCount = thematiquesContainer.querySelectorAll('.thematique-filter-checkbox:checked').length;
            const totalCount = checkboxes.length;
            
            if (totalCount === 0) {
              selectAllThematiquesCheckbox.checked = false;
              selectAllThematiquesCheckbox.indeterminate = false;
            } else if (checkedCount === totalCount) {
              // All are selected
              selectAllThematiquesCheckbox.checked = true;
              selectAllThematiquesCheckbox.indeterminate = false;
            } else if (checkedCount === 0) {
              // None are selected
              selectAllThematiquesCheckbox.checked = false;
              selectAllThematiquesCheckbox.indeterminate = false;
            } else {
              // Mixed state: checkbox in indeterminate state
              selectAllThematiquesCheckbox.checked = false;
              selectAllThematiquesCheckbox.indeterminate = true;
            }
          }, 0);
        }

        thematiquesContainer.appendChild(thematiquesHeader);
        thematiquesContainer.appendChild(thematiquesList);

        // Handle accordion
        thematiquesHeader.addEventListener('click', (e) => {
          // Don't handle click if it's on "Select all" checkbox or filter list items
          // Allow clicks on the title (span) to toggle accordion
          if (e.target === selectAllThematiquesCheckbox || selectAllThematiquesCheckbox.contains(e.target) ||
              thematiquesList.contains(e.target)) {
            return;
          }
          e.stopPropagation();
          const isOpen = thematiquesHeader.className.includes('open');
          if (isOpen) {
            thematiquesList.style.maxHeight = '0';
            thematiquesList.classList.remove('is-open');
            setTimeout(() => {
              if (!thematiquesList.classList.contains('is-open')) {
                thematiquesList.style.display = 'none';
              }
            }, 300);
            thematiquesHeader.className = 'mapster-accordion-indicator-closed';
            thematiquesContainer.className = 'thematiques-filters-container category-parent mapster-accordion-indicator-closed';
          } else {
            thematiquesList.style.display = 'flex';
            thematiquesList.classList.add('is-open');
            setTimeout(() => {
              const scrollHeight = thematiquesList.scrollHeight;
              thematiquesList.style.maxHeight = scrollHeight + 'px';
            }, 10);
            thematiquesHeader.className = 'mapster-accordion-indicator-open';
            thematiquesContainer.className = 'thematiques-filters-container category-parent mapster-accordion-indicator-open';
          }
        });

        // Store data for filtering
        thematiquesContainer._postIdToPairs = postIdToPairs;
        thematiquesContainer._polygons = polygons;

        // Add event listeners for filtering
        const thematiquesCheckboxes = thematiquesList.querySelectorAll('.thematique-filter-checkbox');
        thematiquesCheckboxes.forEach(checkbox => {
          checkbox.addEventListener('change', () => {
            updateThemePopulationFilters();
            updateThematiquesSelectAllCheckboxState();
          });
        });

        updateThematiquesSelectAllCheckboxState();

        // Insert after CPTS filters
        const cptsContainer = bottomLeftCtrl.querySelector('.cpts-filters-container');
        if (cptsContainer && cptsContainer.parentElement) {
          cptsContainer.parentElement.insertBefore(thematiquesContainer, cptsContainer.nextSibling);
        } else {
          const firstUl = bottomLeftCtrl.querySelector('ul');
          if (firstUl) {
            firstUl.appendChild(thematiquesContainer);
          } else {
            bottomLeftCtrl.appendChild(thematiquesContainer);
          }
        }
      }

      // Create Populations filters
      if (populationsSet.size > 0) {
        const populationsContainer = document.createElement('li');
        populationsContainer.className = 'populations-filters-container category-parent mapster-accordion-indicator-closed';

        const populationsHeader = document.createElement('div');
        populationsHeader.className = 'mapster-accordion-indicator-closed';
        populationsHeader.style.cssText = 'display: flex; align-items: center; justify-content: space-between; padding: 12px 16px; cursor: pointer; gap: 0; flex-wrap: wrap;';

        // Checkbox to select/deselect all
        const selectAllPopulationsCheckbox = document.createElement('input');
        selectAllPopulationsCheckbox.type = 'checkbox';
        selectAllPopulationsCheckbox.id = 'populations-select-all-checkbox';
        selectAllPopulationsCheckbox.className = 'populations-select-all-checkbox';
        selectAllPopulationsCheckbox.checked = false; // By default, nothing is selected
        selectAllPopulationsCheckbox.style.cssText = 'flex-shrink: 0; margin-right: 0; cursor: pointer;';

        // Handle click on "Select all/deselect all" checkbox
        selectAllPopulationsCheckbox.addEventListener('change', (e) => {
          e.stopPropagation();
          const checkboxes = populationsContainer.querySelectorAll('.population-filter-checkbox');
          const isChecked = selectAllPopulationsCheckbox.checked;
          checkboxes.forEach(checkbox => {
            checkbox.checked = isChecked;
          });
          updateThemePopulationFilters();
          updatePopulationsSelectAllCheckboxState();
        });

        const populationsLabel = document.createElement('span');
        populationsLabel.textContent = 'Population';
        populationsLabel.style.cssText = 'margin: 0; cursor: pointer; flex: 1;';

        // Container for checkbox + label
        const checkboxLabelContainer = document.createElement('div');
        checkboxLabelContainer.style.cssText = 'display: flex; align-items: center; gap: 8px; flex: 1;';
        checkboxLabelContainer.appendChild(selectAllPopulationsCheckbox);
        checkboxLabelContainer.appendChild(populationsLabel);

        const populationsIndicator = document.createElement('span');
        populationsIndicator.className = 'mapster-accordion-indicator';
        populationsIndicator.style.cssText = 'flex: 0 0 auto; flex-shrink: 0;';

        populationsHeader.appendChild(checkboxLabelContainer);
        populationsHeader.appendChild(populationsIndicator);

        const populationsList = document.createElement('div');
        populationsList.className = 'populations-filters-list';

        const sortedPopulations = Array.from(populationsSet).sort();
        sortedPopulations.forEach((population, index) => {
          const checkboxId = `population-filter-${index}`;
          const label = document.createElement('label');
          label.innerHTML = `
            <input type="checkbox" id="${checkboxId}" value="${population}" class="population-filter-checkbox">
            <span>${population}</span>
          `;
          populationsList.appendChild(label);
        });

        // Function to update "Select all" checkbox state
        function updatePopulationsSelectAllCheckboxState() {
          setTimeout(() => {
            const checkboxes = populationsContainer.querySelectorAll('.population-filter-checkbox');
            const checkedCount = populationsContainer.querySelectorAll('.population-filter-checkbox:checked').length;
            const totalCount = checkboxes.length;
            
            if (totalCount === 0) {
              selectAllPopulationsCheckbox.checked = false;
              selectAllPopulationsCheckbox.indeterminate = false;
            } else if (checkedCount === totalCount) {
              // All are selected
              selectAllPopulationsCheckbox.checked = true;
              selectAllPopulationsCheckbox.indeterminate = false;
            } else if (checkedCount === 0) {
              // None are selected
              selectAllPopulationsCheckbox.checked = false;
              selectAllPopulationsCheckbox.indeterminate = false;
            } else {
              // Mixed state: checkbox in indeterminate state
              selectAllPopulationsCheckbox.checked = false;
              selectAllPopulationsCheckbox.indeterminate = true;
            }
          }, 0);
        }

        populationsContainer.appendChild(populationsHeader);
        populationsContainer.appendChild(populationsList);

        // Handle accordion
        populationsHeader.addEventListener('click', (e) => {
          // Don't handle click if it's on "Select all" checkbox or filter list items
          // Allow clicks on the title (span) to toggle accordion
          if (e.target === selectAllPopulationsCheckbox || selectAllPopulationsCheckbox.contains(e.target) ||
              populationsList.contains(e.target)) {
            return;
          }
          e.stopPropagation();
          const isOpen = populationsHeader.className.includes('open');
          if (isOpen) {
            populationsList.style.maxHeight = '0';
            populationsList.classList.remove('is-open');
            setTimeout(() => {
              if (!populationsList.classList.contains('is-open')) {
                populationsList.style.display = 'none';
              }
            }, 300);
            populationsHeader.className = 'mapster-accordion-indicator-closed';
            populationsContainer.className = 'populations-filters-container category-parent mapster-accordion-indicator-closed';
          } else {
            populationsList.style.display = 'flex';
            populationsList.classList.add('is-open');
            setTimeout(() => {
              const scrollHeight = populationsList.scrollHeight;
              populationsList.style.maxHeight = scrollHeight + 'px';
            }, 10);
            populationsHeader.className = 'mapster-accordion-indicator-open';
            populationsContainer.className = 'populations-filters-container category-parent mapster-accordion-indicator-open';
          }
        });

        // Store data for filtering
        populationsContainer._postIdToPairs = postIdToPairs;
        populationsContainer._polygons = polygons;

        // Add event listeners for filtering
        const populationsCheckboxes = populationsList.querySelectorAll('.population-filter-checkbox');
        populationsCheckboxes.forEach(checkbox => {
          checkbox.addEventListener('change', () => {
            updateThemePopulationFilters();
            updatePopulationsSelectAllCheckboxState();
          });
        });

        updatePopulationsSelectAllCheckboxState();

        // Insert after Themes filters
        const thematiquesContainer = bottomLeftCtrl.querySelector('.thematiques-filters-container');
        if (thematiquesContainer && thematiquesContainer.parentElement) {
          thematiquesContainer.parentElement.insertBefore(populationsContainer, thematiquesContainer.nextSibling);
        } else {
          const firstUl = bottomLeftCtrl.querySelector('ul');
          if (firstUl) {
            firstUl.appendChild(populationsContainer);
          } else {
            bottomLeftCtrl.appendChild(populationsContainer);
          }
        }
      }

    } catch (error) {
      console.error('Error creating thematic/population filters:', error);
    } finally {
      _createThemePopulationFiltersRunning = false;
      
      // Check if sidebar should be shown now
      setTimeout(() => {
        showSidebarWhenReady();
      }, 100);
    }
  }

  // Function to update polygon visibility according to themes/populations filters
  function updateThemePopulationFilters() {
    // Call unified filtering function
    if (typeof window.updateAllFilters === 'function') {
      window.updateAllFilters();
    }
  }

  window.createThemePopulationFilters = createThemePopulationFilters;
  window.updateThemePopulationFilters = updateThemePopulationFilters;

  // ---------- Function to display each polygon's categories in console ----------
  window.logPolygonCategories = async function () {
    const polygons = window.getMapsterPolygons();

    // Get all polygon post_ids
    const postIds = new Set();
    const polygonPostIdMap = new Map(); // Map to associate post_id -> polygons

    polygons.forEach((polygon) => {
      const props = polygon.properties || {};
      const feature = polygon.feature || {};
      const featureProps = feature.properties || {};

      let postId = null;
      if (props.post_id) {
        postId = parseInt(props.post_id);
      } else if (props.id) {
        postId = parseInt(props.id);
      } else if (props.feature_id) {
        postId = parseInt(props.feature_id);
      } else if (featureProps.post_id) {
        postId = parseInt(featureProps.post_id);
      } else if (featureProps.id) {
        postId = parseInt(featureProps.id);
      }

      if (postId && postId > 0) {
        postIds.add(postId);
        if (!polygonPostIdMap.has(postId)) {
          polygonPostIdMap.set(postId, []);
        }
        polygonPostIdMap.get(postId).push(polygon);
      }
    });

    // Get WordPress categories from backend
    let wpCategories = {};
    if (postIds.size > 0) {
      try {
        const ajaxUrl = window.ajaxurl || (window.location.origin + '/wp-admin/admin-ajax.php');
        const postIdsArray = Array.from(postIds);

        const response = await fetch(ajaxUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: new URLSearchParams({
            action: 'get_polygon_categories',
            post_ids: JSON.stringify(postIdsArray)
          })
        });

        if (response.ok) {
          const data = await response.json();
          if (data.success && data.data?.categories) {
            wpCategories = data.data.categories;
          }
        }
      } catch (error) {
        console.error('Error retrieving WordPress categories:', error);
      }
    }

    // Display information for each polygon
    polygons.forEach((polygon, index) => {
      const props = polygon.properties || {};
      const feature = polygon.feature || {};
      const featureProps = feature.properties || {};

      // Get all possible properties containing categories
      const allProps = { ...props, ...featureProps };

      // Search for categories in different possible properties
      const categories = [];
      const categoryFields = [
        'categories',
        'category',
        'wp-map-category',
        'set_categories',
        'category_ids',
        'category_id',
        'cat',
        'cats',
        'taxonomy',
        'wp_map_category'
      ];

      categoryFields.forEach(field => {
        if (allProps[field]) {
          if (Array.isArray(allProps[field])) {
            categories.push(...allProps[field]);
          } else {
            categories.push(allProps[field]);
          }
        }
      });

      // Also search in nested objects
      if (allProps.additional_details) {
        if (typeof allProps.additional_details === 'object') {
          Object.keys(allProps.additional_details).forEach(key => {
            if (key.toLowerCase().includes('categor') || key.toLowerCase().includes('cat')) {
              const value = allProps.additional_details[key];
              if (Array.isArray(value)) {
                categories.push(...value);
              } else if (value) {
                categories.push(value);
              }
            }
          });
        }
      }

      // Get post_id
      let postId = null;
      if (props.post_id) {
        postId = parseInt(props.post_id);
      } else if (props.id) {
        postId = parseInt(props.id);
      } else if (props.feature_id) {
        postId = parseInt(props.feature_id);
      } else if (featureProps.post_id) {
        postId = parseInt(featureProps.post_id);
      } else if (featureProps.id) {
        postId = parseInt(featureProps.id);
      }

      // Get WordPress categories from backend
      const wpCategoriesForPolygon = postId && wpCategories[postId] ? wpCategories[postId] : [];

      // Display polygon information
      const polygonInfo = {
        index: index + 1,
        id: polygon.id || props.id || feature.id || 'N/A',
        postId: postId || 'N/A',
        name: props.name || props.title || props.label || featureProps.name || featureProps.title || 'No name',
        source: polygon.source || 'N/A',
        categoriesFromProps: categories.length > 0 ? [...new Set(categories)] : [],
        wpCategories: wpCategoriesForPolygon,
        allProperties: allProps
      };

    });

    return polygons.map((polygon, index) => {
      const props = polygon.properties || {};
      const feature = polygon.feature || {};
      const featureProps = feature.properties || {};
      const allProps = { ...props, ...featureProps };

      const categories = [];
      const categoryFields = ['categories', 'category', 'wp-map-category', 'set_categories', 'category_ids', 'category_id', 'cat', 'cats', 'taxonomy', 'wp_map_category'];

      categoryFields.forEach(field => {
        if (allProps[field]) {
          if (Array.isArray(allProps[field])) {
            categories.push(...allProps[field]);
          } else {
            categories.push(allProps[field]);
          }
        }
      });

      if (allProps.additional_details && typeof allProps.additional_details === 'object') {
        Object.keys(allProps.additional_details).forEach(key => {
          if (key.toLowerCase().includes('categor') || key.toLowerCase().includes('cat')) {
            const value = allProps.additional_details[key];
            if (Array.isArray(value)) {
              categories.push(...value);
            } else if (value) {
              categories.push(value);
            }
          }
        });
      }

      let postId = null;
      if (props.post_id) {
        postId = parseInt(props.post_id);
      } else if (props.id) {
        postId = parseInt(props.id);
      } else if (props.feature_id) {
        postId = parseInt(props.feature_id);
      } else if (featureProps.post_id) {
        postId = parseInt(featureProps.post_id);
      } else if (featureProps.id) {
        postId = parseInt(featureProps.id);
      }

      const wpCategoriesForPolygon = postId && wpCategories[postId] ? wpCategories[postId] : [];

      return {
        id: polygon.id || props.id || feature.id || null,
        postId: postId,
        name: props.name || props.title || props.label || featureProps.name || featureProps.title || 'No name',
        categoriesFromProps: [...new Set(categories)],
        wpCategories: wpCategoriesForPolygon
      };
    });
  };

  let _initCPTSFiltersRunning = false;

  // Function to check if all filters are ready
  function areAllFiltersReady() {
    const bottomLeftCtrl = document.querySelector('.mapboxgl-ctrl-bottom-left');
    if (!bottomLeftCtrl) return false;

    // Check if CPTS filters exist
    const cptsContainer = bottomLeftCtrl.querySelector('.cpts-filters-container');
    const hasCPTSFilters = cptsContainer && cptsContainer.querySelectorAll('.cpts-filter-checkbox').length > 0;

    // Check if Thematics filters exist (optional - may not always be present)
    const thematiquesContainer = bottomLeftCtrl.querySelector('.thematiques-filters-container');
    const hasThematiquesFilters = thematiquesContainer && thematiquesContainer.querySelectorAll('.thematique-filter-checkbox').length > 0;

    // Check if Populations filters exist (optional - may not always be present)
    const populationsContainer = bottomLeftCtrl.querySelector('.populations-filters-container');
    const hasPopulationsFilters = populationsContainer && populationsContainer.querySelectorAll('.population-filter-checkbox').length > 0;

    // At minimum, CPTS filters must be ready
    // Thematics and Populations are optional (may not exist if no data)
    return hasCPTSFilters;
  }

  // Function to show sidebar loader
  function showSidebarLoader() {
    const bottomLeftCtrl = document.querySelector('.mapboxgl-ctrl-bottom-left');
    if (!bottomLeftCtrl) return;

    // Check if loader already exists
    let loader = bottomLeftCtrl.querySelector('.cpts-sidebar-loader');
    if (!loader) {
      loader = document.createElement('div');
      loader.className = 'cpts-sidebar-loader';
      loader.innerHTML = `
        <div class="cpts-sidebar-loader-spinner"></div>
        <div class="cpts-sidebar-loader-text">Chargement des filtres...</div>
      `;
      bottomLeftCtrl.appendChild(loader);
    }
    loader.style.display = 'flex';
  }

  // Function to hide sidebar loader
  function hideSidebarLoader() {
    const bottomLeftCtrl = document.querySelector('.mapboxgl-ctrl-bottom-left');
    if (!bottomLeftCtrl) return;

    const loader = bottomLeftCtrl.querySelector('.cpts-sidebar-loader');
    if (loader) {
      loader.style.display = 'none';
    }
  }

  // Function to show sidebar when filters are ready
  function showSidebarWhenReady() {
    const bottomLeftCtrl = document.querySelector('.mapboxgl-ctrl-bottom-left');
    if (!bottomLeftCtrl) return;

    if (areAllFiltersReady()) {
      hideSidebarLoader();
      // On desktop, ensure sidebar is visible
      if (!isMobile()) {
        bottomLeftCtrl.style.display = 'flex';
        bottomLeftCtrl.style.visibility = 'visible';
        bottomLeftCtrl.style.opacity = '1';
      }
    } else {
      // Filters not ready yet, show loader
      showSidebarLoader();
      // On desktop, hide sidebar until ready
      if (!isMobile() && !bottomLeftCtrl.dataset.filtersReady) {
        bottomLeftCtrl.style.display = 'none';
      }
    }
  }

  const initCPTSFilters = async () => {
    if (_initCPTSFiltersRunning) {
      return;
    }

    const bottomLeftCtrl = document.querySelector('.mapboxgl-ctrl-bottom-left');
    if (!bottomLeftCtrl) {
      return;
    }

    // On mobile, always recreate filters if sidebar was hidden
    const existingContainer = bottomLeftCtrl.querySelector('.cpts-filters-container');
    if (existingContainer && !isMobile()) {
      // Filters already exist, check if ready
      showSidebarWhenReady();
      return;
    }

    _initCPTSFiltersRunning = true;

    // Show loader while filters are being created
    showSidebarLoader();

    try {
      if (typeof window.getMapsterPolygons === 'function' && typeof window.createCPTSFilters === 'function') {
        const polygons = window.getMapsterPolygons();

        if (polygons && polygons.length > 0) {
          const filtersData = await window.createCPTSFilters();

          if (filtersData && filtersData.filters && filtersData.filters.length > 0) {
            await createCPTSFiltersInSidebar();
          }
        }
      }
      
      // Create Themes and Populations filters
      if (typeof window.createThemePopulationFilters === 'function') {
        await createThemePopulationFilters();
      }

      // Mark filters as ready
      bottomLeftCtrl.dataset.filtersReady = 'true';
      
      // Show sidebar now that filters are ready
      showSidebarWhenReady();
    } catch (error) {
      console.error('Error initCPTSFilters:', error);
      // Even on error, try to show sidebar
      showSidebarWhenReady();
    } finally {
      _initCPTSFiltersRunning = false;
    }
  };

  map.on('load', () => {
    setTimeout(initCPTSFilters, 200);
    // Display categories in console after loading
    setTimeout(() => {
      if (typeof window.logPolygonCategories === 'function') {
        window.logPolygonCategories();
      }
    }, 1000);
  });

  setTimeout(initCPTSFilters, 100);

  // Display categories in console after a delay
  setTimeout(() => {
    if (typeof window.logPolygonCategories === 'function') {
      window.logPolygonCategories();
    }
  }, 2000);

  // ---------- 9) Transform mapboxgl-ctrl-bottom-left into full-height sidebar ----------
  function isMobile() {
    return window.innerWidth <= 768;
  }

  function createMobileOverlay() {
    const existingOverlay = document.getElementById('cpts-mobile-sidebar-overlay');
    if (existingOverlay) {
      return existingOverlay;
    }

    const overlay = document.createElement('div');
    overlay.id = 'cpts-mobile-sidebar-overlay';
    overlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background: rgba(0, 0, 0, 0.5);
      z-index: 999;
      display: none;
      opacity: 0;
      transition: opacity 0.3s ease;
    `;

    overlay.addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      closeMobileSidebar();
    });

    document.body.appendChild(overlay);
    return overlay;
  }

  // Prevent clicks on sidebar from bubbling to overlay
  function setupSidebarClickPrevention() {
    const sidebar = document.querySelector('.mapboxgl-ctrl-bottom-left');
    if (sidebar) {
      sidebar.addEventListener('click', (e) => {
        e.stopPropagation();
      });
    }
  }

  // Track sidebar state
  let mobileSidebarOpen = false;

  async function openMobileSidebar() {
    const sidebar = document.querySelector('.mapboxgl-ctrl-bottom-left');
    const toggle = document.getElementById('cpts-mobile-sidebar-toggle');
    const overlay = document.getElementById('cpts-mobile-sidebar-overlay');
    
    if (!sidebar) return;
    
    // Make sidebar visible but off-screen first so filters can be created
    sidebar.style.position = 'fixed';
    sidebar.style.top = '0';
    sidebar.style.left = '-1000px'; // Off-screen but visible to DOM
    sidebar.style.display = 'flex';
    sidebar.style.visibility = 'visible';
    sidebar.style.opacity = '1';
    sidebar.style.zIndex = '1001';
    sidebar.style.width = '280px';
    sidebar.style.maxWidth = '85vw';
    sidebar.style.height = '100vh';
    sidebar.style.flexDirection = 'column';
    sidebar.style.background = 'rgba(255, 255, 255, 1)';
    sidebar.style.boxShadow = '2px 0 10px rgba(0,0,0,0.3)';
    sidebar.style.padding = '0';
    sidebar.style.margin = '0';
    sidebar.style.overflowY = 'auto';
    
    // Ensure filters are created
    createCheckboxesInSidebar(sidebar);
    
    // Force re-initialization of filters
    _initCPTSFiltersRunning = false;
    await initCPTSFilters();
    
    // Also force creation of theme/population filters
    if (typeof window.createThemePopulationFilters === 'function') {
      await window.createThemePopulationFilters();
    }
    
    // Wait for filters to be added to DOM
    await new Promise(resolve => setTimeout(resolve, 200));
    
    // Now move sidebar to correct position
    sidebar.style.left = '0';
    // Ensure display is still flex (in case transformBottomLeftToSidebar was called)
    sidebar.style.display = 'flex';
    sidebar.style.visibility = 'visible';
    sidebar.style.opacity = '1';
    
    // Prevent clicks on sidebar from closing it
    setupSidebarClickPrevention();
    
      mobileSidebarOpen = true;
      
      if (toggle) {
        toggle.setAttribute('data-open', 'true');
      }
    if (overlay) {
      overlay.style.display = 'block';
      overlay.style.zIndex = '1000';
      setTimeout(() => {
        overlay.style.opacity = '1';
      }, 10);
    }
  }

  function closeMobileSidebar() {
    const sidebar = document.querySelector('.mapboxgl-ctrl-bottom-left');
    const toggle = document.getElementById('cpts-mobile-sidebar-toggle');
    const overlay = document.getElementById('cpts-mobile-sidebar-overlay');
    
    if (!sidebar) return;
    
    sidebar.style.display = 'none';
    sidebar.style.visibility = 'hidden';
    sidebar.style.opacity = '0';
    mobileSidebarOpen = false;
    
    if (toggle) {
      toggle.setAttribute('data-open', 'false');
    }
    if (overlay) {
      overlay.style.opacity = '0';
      setTimeout(() => {
        overlay.style.display = 'none';
      }, 300);
    }
  }

  function createMobileToggle() {
    const existingToggle = document.getElementById('cpts-mobile-sidebar-toggle');
    if (existingToggle) {
      return existingToggle;
    }

    const toggle = document.createElement('button');
    toggle.id = 'cpts-mobile-sidebar-toggle';
    toggle.className = 'cpts-mobile-sidebar-toggle';
    toggle.setAttribute('aria-label', 'Toggle filters');
    toggle.setAttribute('data-open', 'false');
    toggle.innerHTML = `
      <span class="burger-line"></span>
      <span class="burger-line"></span>
      <span class="burger-line"></span>
    `;

    toggle.addEventListener('click', async (e) => {
      e.stopPropagation();
      e.preventDefault();
      
      if (mobileSidebarOpen) {
        closeMobileSidebar();
      } else {
        await openMobileSidebar();
      }
    });

    document.body.appendChild(toggle);
    createMobileOverlay();
    return toggle;
  }

  function transformBottomLeftToSidebar() {
    const bottomLeftCtrl = document.querySelector('.mapboxgl-ctrl-bottom-left');
    if (!bottomLeftCtrl) return;

    const mobile = isMobile();
    const toggle = createMobileToggle();

    if (mobile) {
      // Mobile: sidebar hidden by default, displayed as overlay
      // But don't override display if sidebar is currently open
      const shouldBeVisible = mobileSidebarOpen || bottomLeftCtrl.style.display === 'flex';
      
      Object.assign(bottomLeftCtrl.style, {
        position: 'fixed',
        top: '0',
        left: '0',
        width: '280px',
        maxWidth: '85vw',
        height: '100vh',
        bottom: 'auto',
        right: 'auto',
        display: shouldBeVisible ? 'flex' : 'none',
        flexDirection: 'column',
        background: 'rgba(255, 255, 255, 1)',
        boxShadow: '2px 0 10px rgba(0,0,0,0.3)',
        zIndex: '1001',
        padding: '0',
        margin: '0',
        transform: 'none',
        overflowY: 'auto'
      });

      toggle.classList.add('cpts-mobile-sidebar-toggle-visible');

      const mapContainer = map.getContainer();
      if (mapContainer) {
        mapContainer.style.marginLeft = '0';
        mapContainer.style.width = '100%';
      }

      // Ensure filters are created even when sidebar is hidden
      createCheckboxesInSidebar(bottomLeftCtrl);
      // Also ensure CPTS filters are initialized
      setTimeout(() => {
        initCPTSFilters();
      }, 100);
    } else {
      // Desktop: sidebar visible only when filters are ready
      const filtersReady = bottomLeftCtrl.dataset.filtersReady === 'true' || areAllFiltersReady();
      
      Object.assign(bottomLeftCtrl.style, {
        position: 'fixed',
        top: '0',
        left: '0',
        width: '280px',
        height: '100vh',
        bottom: 'auto',
        right: 'auto',
        display: filtersReady ? 'flex' : 'none',
        flexDirection: 'column',
        background: 'rgba(255, 255, 255, 0.98)',
        boxShadow: '2px 0 10px rgba(0,0,0,0.15)',
        zIndex: 1000,
        padding: '0',
        margin: '0',
        transform: 'none',
        overflowY: 'auto',
        visibility: filtersReady ? 'visible' : 'hidden',
        opacity: filtersReady ? '1' : '0'
      });

      toggle.classList.remove('cpts-mobile-sidebar-toggle-visible');

      const mapContainer = map.getContainer();
      if (mapContainer) {
        const filtersReady = bottomLeftCtrl.dataset.filtersReady === 'true' || areAllFiltersReady();
        if (filtersReady && !mapContainer.dataset.sidebarAdjusted) {
          mapContainer.dataset.sidebarAdjusted = 'true';
          const currentMargin = parseInt(mapContainer.style.marginLeft) || 0;
          mapContainer.style.marginLeft = (280 + currentMargin) + 'px';
          const currentWidth = mapContainer.style.width || '100%';
          if (currentWidth === '100%') {
            mapContainer.style.width = `calc(100% - 280px)`;
          }
        }
      }
      
      // Check if filters are ready and show sidebar
      showSidebarWhenReady();
    }

    createCheckboxesInSidebar(bottomLeftCtrl);

    const directChildren = Array.from(bottomLeftCtrl.children);
    let categoryIndex = 0;

    directChildren.forEach((child) => {
      if (child.classList.contains('category-parent')) {
        return;
      }

      const hasChildElements = child.children.length > 0 ||
        child.querySelector('label') ||
        child.querySelector('input') ||
        child.querySelector('button') ||
        (child.tagName === 'LABEL' && child.querySelector('input'));

      const isGroupingElement = child.tagName === 'FIELDSET' ||
        (child.tagName === 'DIV' && hasChildElements);

      if (isGroupingElement || hasChildElements) {
        const existingClass = child.className || '';
        const categoryClass = existingClass ?
          `category-parent ${existingClass}` :
          `category-parent category-${categoryIndex}`;

        child.className = categoryClass;
        categoryIndex++;
      }
    });

    addResetButtonsToCategories(bottomLeftCtrl);
  }

  // Handle window resize
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      transformBottomLeftToSidebar();
    }, 250);
  });

  transformBottomLeftToSidebar();
  setTimeout(transformBottomLeftToSidebar, 100);
  setTimeout(transformBottomLeftToSidebar, 500);

  const observer = new MutationObserver((mutations) => {
    let isOurChange = false;
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1 && (node.classList?.contains('cpts-filters-container') || node.querySelector?.('.cpts-filters-container'))) {
          isOurChange = true;
        }
      });
    });

    if (isOurChange) {
      return;
    }

    transformBottomLeftToSidebar();
    translateResetButton();
    const bottomLeftCtrl = document.querySelector('.mapboxgl-ctrl-bottom-left');
    if (bottomLeftCtrl) {
      addResetButtonsToCategories(bottomLeftCtrl);
      setTimeout(() => addResetButtonsToCategories(bottomLeftCtrl), 100);
      setTimeout(() => addResetButtonsToCategories(bottomLeftCtrl), 500);
    }
    if (!preventAutoClose) {
      closeAllMapsterAccordions();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  setTimeout(() => {
    const bottomLeftCtrl = document.querySelector('.mapboxgl-ctrl-bottom-left');
    if (bottomLeftCtrl) {
      addResetButtonsToCategories(bottomLeftCtrl);
    }
  }, 1000);

  setTimeout(() => {
    const bottomLeftCtrl = document.querySelector('.mapboxgl-ctrl-bottom-left');
    if (bottomLeftCtrl) {
      addResetButtonsToCategories(bottomLeftCtrl);
    }
  }, 2000);

  // ---------- 10) Automatically close all Mapster accordions on load only ----------
  let preventAutoClose = false;

  function closeAllMapsterAccordions() {
    if (preventAutoClose) return;

    const bottomLeftCtrl = document.querySelector('.mapboxgl-ctrl-bottom-left');
    if (!bottomLeftCtrl) return;

    const openAccordions = bottomLeftCtrl.querySelectorAll('.mapster-accordion-indicator-open');

    openAccordions.forEach(accordion => {
      if (accordion.closest('.cpts-filters-container')) {
        return;
      }
      accordion.classList.remove('mapster-accordion-indicator-open');
      accordion.classList.add('mapster-accordion-indicator-closed');

      const content = accordion.querySelector('ul');
      if (content) {
        content.style.display = 'none';
      }
    });
  }

  function setupAccordionClickHandlers() {
    const bottomLeftCtrl = document.querySelector('.mapboxgl-ctrl-bottom-left');
    if (!bottomLeftCtrl) return;

    const accordionElements = bottomLeftCtrl.querySelectorAll('.mapster-accordion-indicator-closed, .mapster-accordion-indicator-open');

    accordionElements.forEach(accordion => {
      const triggers = accordion.querySelectorAll('label, input, .mapster-accordion-indicator');

      triggers.forEach(trigger => {
        if (!trigger.dataset.userInteractionHandled) {
          trigger.dataset.userInteractionHandled = 'true';

          trigger.addEventListener('click', (e) => {
            preventAutoClose = true;
          }, { capture: true });
        }
      });
    });
  }

  document.addEventListener('click', (e) => {
    const bottomLeftCtrl = document.querySelector('.mapboxgl-ctrl-bottom-left');
    if (bottomLeftCtrl && bottomLeftCtrl.contains(e.target)) {
      preventAutoClose = true;
    }
  }, { once: true });

  closeAllMapsterAccordions();
  setTimeout(closeAllMapsterAccordions, 100);
  setTimeout(closeAllMapsterAccordions, 500);
  setTimeout(closeAllMapsterAccordions, 1000);
  setTimeout(closeAllMapsterAccordions, 2000);

  setTimeout(setupAccordionClickHandlers, 100);
  setTimeout(setupAccordionClickHandlers, 500);
  setTimeout(setupAccordionClickHandlers, 1000);

  setTimeout(() => {
    preventAutoClose = true;
  }, 3000);

  let bodyObserverActive = true;
  const bodyObserver = new MutationObserver(() => {
    if (!preventAutoClose && bodyObserverActive) {
      const bottomLeftCtrl = document.querySelector('.mapboxgl-ctrl-bottom-left');
      if (bottomLeftCtrl) {
        closeAllMapsterAccordions();
        setupAccordionClickHandlers();
      }
    } else {
      bodyObserverActive = false;
    }
  });

  bodyObserver.observe(document.body, { childList: true, subtree: true });

  setTimeout(() => {
    if (preventAutoClose) {
      bodyObserver.disconnect();
      bodyObserverActive = false;
    }
  }, 3000);

  function addResetButtonsToCategories(container) {
    const allPossibleCategories = container.querySelectorAll('li, div, fieldset');
    const categoriesToProcess = [];

    allPossibleCategories.forEach(element => {
      if (element.classList.contains('cpts-filters-container') || element.classList.contains('ui-map-checkbox-list')) {
        return;
      }

      if (element.dataset.resetButtonAdded === 'true') {
        return;
      }

      const hasCategoryLabel = Array.from(element.querySelectorAll('label')).some(label => {
        const text = label.textContent?.trim() || '';
        const lowerText = text.toLowerCase();
        if (lowerText.includes('niveaux géographiques')) {
          return false;
        }
        return lowerText === 'thématiques' ||
          lowerText === 'thématique' ||
          lowerText === 'population' ||
          lowerText === 'cpts';
      });

      if (hasCategoryLabel || element.classList.contains('category-parent')) {
        categoriesToProcess.push(element);
      }
    });

    categoriesToProcess.forEach(category => {
      if (category.dataset.resetButtonAdded === 'true') {
        return;
      }

      let headerLabel = null;
      let header = null;

      if (category.classList.contains('mapster-accordion-indicator-closed') ||
        category.classList.contains('mapster-accordion-indicator-open')) {
        header = category;
      } else {
        header = category.querySelector('.mapster-accordion-indicator-closed, .mapster-accordion-indicator-open');
        if (!header) {
          header = category.firstElementChild;
        }
      }

      if (header) {
        const allHeaderLabels = Array.from(header.querySelectorAll('label'));

        for (const label of allHeaderLabels) {
          const labelText = label.textContent?.trim() || '';
          const lowerText = labelText.toLowerCase().replace(/\s+/g, ' ').trim();

          if (lowerText.includes('niveaux géographiques')) {
            continue;
          }

          if (lowerText === 'thématiques' ||
            lowerText === 'thématique' ||
            lowerText === 'population' ||
            lowerText === 'cpts') {
            const hasCheckbox = label.querySelector('input[type="checkbox"], input[type="radio"]');
            if (hasCheckbox) continue;

            const hasForAttribute = label.hasAttribute('for');
            let isAssociatedWithListInput = false;

            if (hasForAttribute) {
              const forId = label.getAttribute('for');
              const associatedInput = document.getElementById(forId);
              if (associatedInput && (associatedInput.type === 'checkbox' || associatedInput.type === 'radio')) {
                const inputParent = associatedInput.closest('ul, ol');
                if (inputParent) {
                  const isInCategoryList = category.contains(inputParent) && inputParent !== header;
                  const isSiblingList = category.nextElementSibling === inputParent;
                  if (isInCategoryList || isSiblingList) {
                    isAssociatedWithListInput = true;
                  }
                }
              }
            }

            if (!isAssociatedWithListInput) {
              headerLabel = label;
              break;
            }
          }
        }
      }

      if (!headerLabel) {
        const allCategoryLabels = Array.from(category.querySelectorAll('label'));
        for (const label of allCategoryLabels) {
          const labelText = label.textContent?.trim() || '';
          const lowerText = labelText.toLowerCase().replace(/\s+/g, ' ').trim();

          if (lowerText.includes('niveaux géographiques')) {
            continue;
          }

          if (lowerText === 'thématiques' ||
            lowerText === 'thématique' ||
            lowerText === 'population' ||
            lowerText === 'cpts') {
            const hasCheckbox = label.querySelector('input[type="checkbox"], input[type="radio"]');
            if (hasCheckbox) continue;

            const hasForAttribute = label.hasAttribute('for');
            let isAssociatedWithListInput = false;

            if (hasForAttribute) {
              const forId = label.getAttribute('for');
              const associatedInput = document.getElementById(forId);
              if (associatedInput && (associatedInput.type === 'checkbox' || associatedInput.type === 'radio')) {
                const inputParent = associatedInput.closest('ul, ol');
                if (inputParent) {
                  const isInCategoryList = category.contains(inputParent) && inputParent !== header;
                  const isSiblingList = category.nextElementSibling === inputParent;
                  if (isInCategoryList || isSiblingList) {
                    isAssociatedWithListInput = true;
                  }
                }
              }
            }

            if (!isAssociatedWithListInput) {
              const labelParent = label.closest('li, fieldset, div.category-parent');
              if (labelParent === category) {
                const isInList = label.closest('ul, ol');
                if (!isInList || isInList.parentElement === category) {
                  headerLabel = label;
                  break;
                }
              }
            }
          }
        }
      }

      if (!headerLabel) {
        return;
      }

      const categoryName = headerLabel.textContent?.trim() || '';
      const categoryNameLower = categoryName.toLowerCase().replace(/\s+/g, ' ').trim();

      if (!categoryName || categoryNameLower === 'niveaux géographiques') {
        return;
      }

      const isValidCategory = categoryNameLower === 'thématiques' ||
        categoryNameLower === 'thématique' ||
        categoryNameLower === 'population' ||
        categoryNameLower === 'cpts';

      if (!isValidCategory) {
        return;
      }

      const labelCategory = headerLabel.closest('li, fieldset, div.category-parent');
      if (labelCategory && labelCategory !== category) {
        return;
      }

      if (!header) {
        header = headerLabel.closest('.mapster-accordion-indicator-closed, .mapster-accordion-indicator-open');
        if (!header) {
          header = headerLabel.parentElement;
          if (!header || header === category) {
            const firstChild = category.firstElementChild;
            if (firstChild) {
              header = firstChild;
            } else {
              return;
            }
          }
        }
      }

      const headerLabelInHeader = header.querySelector('label');
      if (headerLabelInHeader && headerLabelInHeader !== headerLabel) {
        const headerLabelText = headerLabelInHeader.textContent?.trim() || '';
        const headerLabelLower = headerLabelText.toLowerCase().replace(/\s+/g, ' ').trim();
        if (headerLabelLower === categoryNameLower) {
          headerLabel = headerLabelInHeader;
        }
      }

      const existingResetBtn = header.querySelector('.category-reset-btn') || category.querySelector('.category-reset-btn');
      if (existingResetBtn) {
        return;
      }

      const headerInputs = header ? header.querySelectorAll('input[type="checkbox"], input[type="radio"]') : [];
      const headerInputIds = new Set(Array.from(headerInputs).map(input => input.id));

      let allCategoryCheckboxes = category.querySelectorAll('input[type="checkbox"]:not(.toggle-switch)');
      let allCategoryRadios = category.querySelectorAll('input[type="radio"]');

      if (category.nextElementSibling && category.nextElementSibling.tagName === 'UL') {
        const siblingList = category.nextElementSibling;
        const siblingCheckboxes = siblingList.querySelectorAll('input[type="checkbox"]:not(.toggle-switch)');
        const siblingRadios = siblingList.querySelectorAll('input[type="radio"]');
        allCategoryCheckboxes = Array.from(allCategoryCheckboxes).concat(Array.from(siblingCheckboxes));
        allCategoryRadios = Array.from(allCategoryRadios).concat(Array.from(siblingRadios));
      }

      const checkboxes = Array.from(allCategoryCheckboxes).filter(cb => {
        if (headerInputIds.has(cb.id)) return false;
        if (header && header.contains(cb)) return false;
        const cbParent = cb.closest('ul, ol');
        if (!cbParent) return true;
        if (cbParent === category.nextElementSibling) return true;
        return cbParent.parentElement === category || category.contains(cbParent);
      });

      const radioButtons = Array.from(allCategoryRadios).filter(radio => {
        if (headerInputIds.has(radio.id)) return false;
        if (header && header.contains(radio)) return false;
        const radioParent = radio.closest('ul, ol');
        if (!radioParent) return true;
        if (radioParent === category.nextElementSibling) return true;
        return radioParent.parentElement === category || category.contains(radioParent);
      });

      const allInputs = checkboxes.length > 0 ? checkboxes : radioButtons;

      if (allInputs.length === 0) {
        return;
      }

      const resetButton = document.createElement('button');
      resetButton.className = 'category-reset-btn';
      resetButton.setAttribute('data-category', categoryName);
      resetButton.textContent = 'Rétablir';
      resetButton.style.cssText = 'display: none; margin-left: auto; padding: 4px 12px; font-size: 12px; background: #232c51; color: white; border: none; border-radius: 4px; cursor: pointer; order: 4; pointer-events: auto; z-index: 10; position: relative;';

      function updateResetButtonVisibility() {
        setTimeout(() => {
          const headerInputs = header ? header.querySelectorAll('input[type="checkbox"], input[type="radio"]') : [];
          const headerInputIds = new Set(Array.from(headerInputs).map(input => input.id));

          let allCurrentCheckboxes = category.querySelectorAll('input[type="checkbox"]:not(.toggle-switch)');
          let allCurrentRadios = category.querySelectorAll('input[type="radio"]');

          if (category.nextElementSibling && category.nextElementSibling.tagName === 'UL') {
            const siblingList = category.nextElementSibling;
            const siblingCheckboxes = siblingList.querySelectorAll('input[type="checkbox"]:not(.toggle-switch)');
            const siblingRadios = siblingList.querySelectorAll('input[type="radio"]');
            allCurrentCheckboxes = Array.from(allCurrentCheckboxes).concat(Array.from(siblingCheckboxes));
            allCurrentRadios = Array.from(allCurrentRadios).concat(Array.from(siblingRadios));
          }

          const currentCheckboxes = Array.from(allCurrentCheckboxes).filter(cb => {
            if (headerInputIds.has(cb.id)) return false;
            if (header && header.contains(cb)) return false;
            const cbParent = cb.closest('ul, ol');
            if (!cbParent) return true;
            if (cbParent === category.nextElementSibling) return true;
            return cbParent.parentElement === category || category.contains(cbParent);
          });

          const currentRadios = Array.from(allCurrentRadios).filter(radio => {
            if (headerInputIds.has(radio.id)) return false;
            if (header && header.contains(radio)) return false;
            const radioParent = radio.closest('ul, ol');
            if (!radioParent) return true;
            if (radioParent === category.nextElementSibling) return true;
            return radioParent.parentElement === category || category.contains(radioParent);
          });

          if (currentCheckboxes.length > 0) {
            const checkedCount = currentCheckboxes.filter(cb => cb.checked).length;
            const totalCount = currentCheckboxes.length;
            if (checkedCount < totalCount && totalCount > 0) {
              resetButton.style.display = 'block';
            } else {
              resetButton.style.display = 'none';
            }
          } else if (currentRadios.length > 0) {
            const checkedRadios = currentRadios.filter(radio => radio.checked);
            const radioGroups = new Set();
            currentRadios.forEach(radio => {
              if (radio.name) {
                radioGroups.add(radio.name);
              }
            });

            if (radioGroups.size > 0) {
              let hasUncheckedGroup = false;
              radioGroups.forEach(groupName => {
                const groupRadios = currentRadios.filter(r => r.name === groupName);
                const groupChecked = groupRadios.find(r => r.checked);
                if (!groupChecked) {
                  hasUncheckedGroup = true;
                }
              });
              if (hasUncheckedGroup) {
                resetButton.style.display = 'block';
              } else {
                resetButton.style.display = 'none';
              }
            } else {
              const checkedCount = checkedRadios.length;
              const totalCount = currentRadios.length;
              if (checkedCount < totalCount && totalCount > 0) {
                resetButton.style.display = 'block';
              } else {
                resetButton.style.display = 'none';
              }
            }
          } else {
            resetButton.style.display = 'none';
          }
        }, 0);
      }

      resetButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (checkboxes.length > 0) {
          checkboxes.forEach(checkbox => {
            checkbox.checked = true;
            const changeEvent = new Event('change', { bubbles: true, cancelable: true });
            checkbox.dispatchEvent(changeEvent);
          });
        } else if (radioButtons.length > 0) {
          const radioGroups = new Map();
          radioButtons.forEach(radio => {
            if (radio.name) {
              if (!radioGroups.has(radio.name)) {
                radioGroups.set(radio.name, []);
              }
              radioGroups.get(radio.name).push(radio);
            }
          });

          radioGroups.forEach((radios, groupName) => {
            if (radios.length > 0) {
              radios[0].checked = true;
              const changeEvent = new Event('change', { bubbles: true, cancelable: true });
              radios[0].dispatchEvent(changeEvent);
            }
          });
        }
        updateResetButtonVisibility();
      });

      resetButton.addEventListener('mouseenter', (e) => {
        e.preventDefault();
        e.stopPropagation();
      });

      resetButton.addEventListener('mouseleave', (e) => {
        e.preventDefault();
        e.stopPropagation();
      });

      resetButton.addEventListener('mousedown', (e) => {
        e.preventDefault();
        e.stopPropagation();
      });

      resetButton.addEventListener('mouseup', (e) => {
        e.preventDefault();
        e.stopPropagation();
      });

      if (header === category && headerLabel) {
        if (headerLabel.parentElement === header) {
          header.appendChild(resetButton);
        } else if (headerLabel.parentElement) {
          headerLabel.parentElement.appendChild(resetButton);
        } else {
          header.appendChild(resetButton);
        }
      } else if (headerLabel && headerLabel.parentElement === header) {
        header.appendChild(resetButton);
      } else if (headerLabel && headerLabel.parentElement) {
        headerLabel.parentElement.appendChild(resetButton);
      } else if (header) {
        header.appendChild(resetButton);
      } else {
        category.appendChild(resetButton);
      }

      if (header) {
        header.style.display = 'flex';
        header.style.alignItems = 'center';
        header.style.justifyContent = 'space-between';
      }

      category.dataset.resetButtonAdded = 'true';

      if (checkboxes.length > 0) {
        checkboxes.forEach(checkbox => {
          const originalHandler = checkbox.onchange;
          checkbox.addEventListener('change', () => {
            updateResetButtonVisibility();
            if (originalHandler) {
              originalHandler.call(checkbox);
            }
          });
        });
      } else if (radioButtons.length > 0) {
        radioButtons.forEach(radio => {
          const originalHandler = radio.onchange;
          radio.addEventListener('change', () => {
            updateResetButtonVisibility();
            if (originalHandler) {
              originalHandler.call(radio);
            }
          });
        });
      }

      updateResetButtonVisibility();

      setTimeout(() => {
        updateResetButtonVisibility();
      }, 100);

      setTimeout(() => {
        updateResetButtonVisibility();
      }, 500);

      setTimeout(() => {
        updateResetButtonVisibility();
      }, 1000);
    });
  }

  function updateAllCategoryResetButtons() {
    const bottomLeftCtrl = document.querySelector('.mapboxgl-ctrl-bottom-left');
    if (!bottomLeftCtrl) return;

    const allResetButtons = bottomLeftCtrl.querySelectorAll('.category-reset-btn');
    allResetButtons.forEach(button => {
      const category = button.closest('li, fieldset, div.category-parent');
      if (!category) return;

      const header = category.querySelector('.mapster-accordion-indicator-closed, .mapster-accordion-indicator-open') ||
        (category.classList.contains('mapster-accordion-indicator-closed') ||
          category.classList.contains('mapster-accordion-indicator-open') ? category : null) ||
        category.firstElementChild;

      if (!header) return;

      const headerInputs = header ? header.querySelectorAll('input[type="checkbox"], input[type="radio"]') : [];
      const headerInputIds = new Set(Array.from(headerInputs).map(input => input.id));

      let allCategoryCheckboxes = category.querySelectorAll('input[type="checkbox"]:not(.toggle-switch)');
      let allCategoryRadios = category.querySelectorAll('input[type="radio"]');

      if (category.nextElementSibling && category.nextElementSibling.tagName === 'UL') {
        const siblingList = category.nextElementSibling;
        const siblingCheckboxes = siblingList.querySelectorAll('input[type="checkbox"]:not(.toggle-switch)');
        const siblingRadios = siblingList.querySelectorAll('input[type="radio"]');
        allCategoryCheckboxes = Array.from(allCategoryCheckboxes).concat(Array.from(siblingCheckboxes));
        allCategoryRadios = Array.from(allCategoryRadios).concat(Array.from(siblingRadios));
      }

      const checkboxes = Array.from(allCategoryCheckboxes).filter(cb => {
        if (headerInputIds.has(cb.id)) return false;
        if (header && header.contains(cb)) return false;
        const cbParent = cb.closest('ul, ol');
        if (!cbParent) return true;
        if (cbParent === category.nextElementSibling) return true;
        return cbParent.parentElement === category || category.contains(cbParent);
      });

      const radios = Array.from(allCategoryRadios).filter(radio => {
        if (headerInputIds.has(radio.id)) return false;
        if (header && header.contains(radio)) return false;
        const radioParent = radio.closest('ul, ol');
        if (!radioParent) return true;
        if (radioParent === category.nextElementSibling) return true;
        return radioParent.parentElement === category || category.contains(radioParent);
      });

      const allInputs = checkboxes.length > 0 ? checkboxes : radios;

      if (allInputs.length > 0) {
        if (checkboxes.length > 0) {
          const checkedCount = checkboxes.filter(cb => cb.checked).length;
          const totalCount = checkboxes.length;
          if (checkedCount < totalCount && totalCount > 0) {
            button.style.display = 'block';
          } else {
            button.style.display = 'none';
          }
        } else if (radios.length > 0) {
          const checkedRadios = radios.filter(radio => radio.checked);
          const radioGroups = new Set();
          radios.forEach(radio => {
            if (radio.name) {
              radioGroups.add(radio.name);
            }
          });

          if (radioGroups.size > 0) {
            let hasUncheckedGroup = false;
            radioGroups.forEach(groupName => {
              const groupRadios = radios.filter(r => r.name === groupName);
              const groupChecked = groupRadios.find(r => r.checked);
              if (!groupChecked) {
                hasUncheckedGroup = true;
              }
            });
            if (hasUncheckedGroup) {
              button.style.display = 'block';
            } else {
              button.style.display = 'none';
            }
          } else {
            const checkedCount = checkedRadios.length;
            const totalCount = radios.length;
            if (checkedCount < totalCount && totalCount > 0) {
              button.style.display = 'block';
            } else {
              button.style.display = 'none';
            }
          }
        } else {
          button.style.display = 'none';
        }
      } else {
        button.style.display = 'none';
      }
    });
  }

  function resetCPTSFilters() {
    const bottomLeftCtrl = document.querySelector('.mapboxgl-ctrl-bottom-left');
    if (!bottomLeftCtrl) return;

    const cptsContainer = bottomLeftCtrl.querySelector('.cpts-filters-container');
    if (!cptsContainer) return;

    const checkboxes = cptsContainer.querySelectorAll('.cpts-filter-checkbox');
    checkboxes.forEach(checkbox => {
      checkbox.checked = true;
    });

    const updateCPTSFiltersVisibility = cptsContainer._updateCPTSFiltersVisibility;
    if (typeof updateCPTSFiltersVisibility === 'function') {
      updateCPTSFiltersVisibility();
    }

    setTimeout(() => {
      updateAllCategoryResetButtons();
    }, 200);
  }

  function translateResetButton() {
    const resetBtn = document.getElementById('mapster-reset-categories');
    if (resetBtn) {
      if (resetBtn.textContent.trim().toLowerCase() === 'reset' ||
        resetBtn.textContent.trim().toLowerCase().includes('reset')) {
        resetBtn.textContent = 'Réinitialiser';
      } else if (resetBtn.value && resetBtn.value.trim().toLowerCase() === 'reset') {
        resetBtn.value = 'Réinitialiser';
      }

      if (!resetBtn.dataset.cptsResetHandlerAdded) {
        resetBtn.dataset.cptsResetHandlerAdded = 'true';
        resetBtn.addEventListener('click', (e) => {
          setTimeout(() => {
            resetCPTSFilters();
            updateAllCategoryResetButtons();
          }, 100);
        });
      }
    }
  }

  translateResetButton();
  setTimeout(translateResetButton, 100);
  setTimeout(translateResetButton, 500);


  function setThematiquesVisibility(popupContent, show) {
    if (!popupContent) return;

    const thematiquesList = popupContent.querySelector('.thematiques-list');
    if (!thematiquesList) {
      return;
    }

    const thematiquesSection = thematiquesList.closest('.thematiques-section') ||
      thematiquesList.parentElement?.closest('.thematiques-section') ||
      thematiquesList.parentElement;

    if (thematiquesSection) {
      thematiquesSection.style.display = show ? '' : 'none';
    }

    const thematiquesSeparator = popupContent.querySelector('.thematiques-separator');
    if (thematiquesSeparator) {
      thematiquesSeparator.style.backgroundColor = show ? '' : 'transparent';
    }
  }

  function hideThematiquesSectionByDefault() {
    let popup = document.querySelector('.maplibregl-popup-content');
    if (!popup) {
      popup = document.querySelector('.mapboxgl-popup-content');
    }
    if (!popup) {
      popup = document.querySelector('.maplibregl-popup');
    }
    if (!popup) return;

    let popupContent = popup.querySelector('#mapster-popup, .map-popup-background, .mapster-popup-shortcode-content');
    if (!popupContent) {
      popupContent = popup;
    }

    setThematiquesVisibility(popupContent, false);
  }

  // Safeguard to prevent multiple simultaneous calls
  let _addCategoriesToPopupRunning = false;
  let _addCategoriesToPopupTimeout = null;

  async function addCategoriesToPopup() {
    // Debounce: cancel previous call if it exists
    if (_addCategoriesToPopupTimeout) {
      clearTimeout(_addCategoriesToPopupTimeout);
      _addCategoriesToPopupTimeout = null;
    }

    // If already running, ignore
    if (_addCategoriesToPopupRunning) {
      return;
    }

    let popup = document.querySelector('.maplibregl-popup-content');
    if (!popup) {
      popup = document.querySelector('.mapboxgl-popup-content');
    }
    if (!popup) {
      popup = document.querySelector('.maplibregl-popup');
    }
    if (!popup) return;

    let popupContent = popup.querySelector('#mapster-popup, .map-popup-background, .mapster-popup-shortcode-content');
    if (!popupContent) {
      popupContent = popup;
    }

    // Check if already processed
    if (popupContent.dataset.categoriesProcessed === 'true' || popupContent.dataset.categoriesProcessed === 'processing') {
      return;
    }

    // Mark as processing
    _addCategoriesToPopupRunning = true;

    const thematiquesList = popupContent.querySelector('.thematiques-list');
    if (!thematiquesList) {
      _addCategoriesToPopupRunning = false;
      return;
    }

    // Keep section visible by default (title is already in HTML template)
    // Only hide if no thematics are found after loading

    const existingCategories = thematiquesList.querySelectorAll('[data-theme-pair]');
    if (existingCategories.length > 0) {
      popupContent.dataset.categoriesProcessed = 'true';
      // Section is already visible, no need to show it
      _addCategoriesToPopupRunning = false;
      return;
    }

    popupContent.dataset.categoriesProcessed = 'processing';

    let postId = null;

    const popupData = popupContent.querySelector('[data-post-id]');
    if (popupData) {
      postId = parseInt(popupData.getAttribute('data-post-id'));
    }

    if (!postId && window._lastClickedFeature) {
      const props = window._lastClickedFeature.properties || {};
      if (props.post_id) {
        postId = parseInt(props.post_id);
      } else if (props.id) {
        postId = parseInt(props.id);
      } else if (props.feature_id) {
        postId = parseInt(props.feature_id);
      }
    }

    if (!postId) {
      const allText = popupContent.textContent || '';
      const idMatch = allText.match(/post[_\s-]?id[:\s]*(\d+)/i) || allText.match(/id[:\s]*(\d+)/i);
      if (idMatch) {
        postId = parseInt(idMatch[1]);
      }
    }

    if (!postId) {
      const polygons = window.getMapsterPolygons();
      if (polygons && polygons.length > 0 && window._lastClickedFeature) {
        const clickedFeature = window._lastClickedFeature;
        const matchingPolygon = polygons.find(p => {
          return (p.id === clickedFeature.id) ||
            (p.feature?.id === clickedFeature.id) ||
            (p.properties?.id === clickedFeature.properties?.id);
        });

        if (matchingPolygon) {
          const props = matchingPolygon.properties || {};
          const featureProps = matchingPolygon.feature?.properties || {};
          if (props.post_id) {
            postId = parseInt(props.post_id);
          } else if (props.id) {
            postId = parseInt(props.id);
          } else if (props.feature_id) {
            postId = parseInt(props.feature_id);
          } else if (featureProps.post_id) {
            postId = parseInt(featureProps.post_id);
          } else if (featureProps.id) {
            postId = parseInt(featureProps.id);
          }
        }
      }
    }

    if (!postId || postId <= 0) {
      // No post ID found, hide the section
      popupContent.dataset.categoriesProcessed = 'true';
      setThematiquesVisibility(popupContent, false);
      _addCategoriesToPopupRunning = false;
      return;
    }

    try {
      const ajaxUrl = window.ajaxurl || (window.location.origin + '/wp-admin/admin-ajax.php');
      const response = await fetch(ajaxUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          action: 'get_polygon_custom_properties',
          post_ids: JSON.stringify([postId])
        })
      });

      if (response.ok) {
        const data = await response.json();
        if (data.success && data.data?.custom_properties && data.data.custom_properties[postId]) {
          const themePopulationPairs = data.data.custom_properties[postId];

          if (themePopulationPairs.length > 0 && thematiquesList) {
            const alreadyAdded = thematiquesList.querySelectorAll('[data-theme-pair]');
            if (alreadyAdded.length > 0) {
              popupContent.dataset.categoriesProcessed = 'true';
              setThematiquesVisibility(popupContent, true);
              _addCategoriesToPopupRunning = false;
              return;
            }

            const isList = thematiquesList.tagName === 'UL' || thematiquesList.tagName === 'OL';
            const itemTag = isList ? 'li' : 'span';

            // Clear existing list
            thematiquesList.innerHTML = '';

            // Deduplicate theme/population pairs
            const uniquePairs = [];
            const seenPairs = new Set();
            themePopulationPairs.forEach(pair => {
              const pairKey = pair.theme + '|' + pair.population;
              if (!seenPairs.has(pairKey)) {
                seenPairs.add(pairKey);
                uniquePairs.push(pair);
              }
            });

            uniquePairs.forEach((pair, index) => {
              const pairItem = document.createElement(itemTag);
              pairItem.setAttribute('data-theme-pair', pair.index);
              
              // Create content with theme + population in gray
              const themeSpan = document.createElement('span');
              themeSpan.textContent = pair.theme;
              themeSpan.style.fontWeight = 'normal';
              
              const populationSpan = document.createElement('span');
              populationSpan.textContent = ' - ' + pair.population;
              populationSpan.style.color = '#666';
              populationSpan.style.fontSize = '0.9em';
              
              pairItem.appendChild(themeSpan);
              pairItem.appendChild(populationSpan);

              if (!isList) {
                pairItem.className = 'theme-population-pair';
                if (index > 0) {
                  const separator = document.createTextNode(', ');
                  thematiquesList.appendChild(separator);
                }
              }

              thematiquesList.appendChild(pairItem);
            });

            popupContent.dataset.categoriesProcessed = 'true';

            if (thematiquesList.style.display === 'none') {
              thematiquesList.style.display = '';
            }

            // Section is already visible, no need to show it
          } else {
            // No thematics found, hide the section
            popupContent.dataset.categoriesProcessed = 'true';
            setThematiquesVisibility(popupContent, false);
          }
        } else {
          // No data found, hide the section
          popupContent.dataset.categoriesProcessed = 'true';
          setThematiquesVisibility(popupContent, false);
        }
      } else {
        // Request failed, hide the section
        popupContent.dataset.categoriesProcessed = 'true';
        setThematiquesVisibility(popupContent, false);
      }
    } catch (error) {
      console.error('Error adding thematics/populations:', error);
      // Error occurred, hide the section
      popupContent.dataset.categoriesProcessed = 'true';
      setThematiquesVisibility(popupContent, false);
    } finally {
      _addCategoriesToPopupRunning = false;
    }
  }

  // Wrapper function with debounce
  function addCategoriesToPopupDebounced() {
    if (_addCategoriesToPopupTimeout) {
      clearTimeout(_addCategoriesToPopupTimeout);
    }
    _addCategoriesToPopupTimeout = setTimeout(() => {
      addCategoriesToPopup();
      _addCategoriesToPopupTimeout = null;
    }, 100);
  }

  let _lastClickedFeature = null;
  let _lastClickLngLat = null;
  let _popupRecentered = false;
  
  map.on('click', (e) => {
    
    const features = map.queryRenderedFeatures(e.point, {
      layers: map.getStyle().layers.filter(layer =>
        layer.type === 'fill' || layer.type === 'line'
      ).map(layer => layer.id)
    });

    if (features.length > 0) {
      _lastClickedFeature = features[0];
      window._lastClickedFeature = features[0];
      // Store click coordinates for recentering map when popup opens
      _lastClickLngLat = e.lngLat;
      window._lastClickLngLat = e.lngLat;
      // Reset recentering flag for new popup
      _popupRecentered = false;
      window._popupRecentered = false;

      setTimeout(() => {
        let popup = document.querySelector('.maplibregl-popup-content');
        if (!popup) {
          popup = document.querySelector('.mapboxgl-popup-content');
        }
        if (popup) {
          let popupContent = popup.querySelector('#mapster-popup, .map-popup-background, .mapster-popup-shortcode-content');
          if (!popupContent) {
            popupContent = popup;
          }
          // Reset only if popup has changed
          if (!popupContent.dataset.lastPostId || popupContent.dataset.lastPostId !== String(window._lastClickedFeature?.properties?.post_id || '')) {
            delete popupContent.dataset.categoriesProcessed;
            if (window._lastClickedFeature?.properties?.post_id) {
              popupContent.dataset.lastPostId = String(window._lastClickedFeature.properties.post_id);
            }
          }
        }
      }, 100);
    }

    requestAnimationFrame(() => {
      hideEmptyPopupSections();
      hideEmptyPopupTitles();
    });
    setTimeout(() => {
      hideEmptyPopupSections();
      hideEmptyPopupTitles();
    }, 10);
    setTimeout(() => {
      hideEmptyPopupSections();
      hideEmptyPopupTitles();
    }, 50);
    setTimeout(() => {
      hideEmptyPopupSections();
      hideEmptyPopupTitles();
    }, 100);
    addCategoriesToPopupDebounced();
  });

  // ---------- 12a) Hide empty info-item sections in popups ----------
  function hideEmptyPopupSections() {
    let popup = document.querySelector('.maplibregl-popup-content');
    if (!popup) {
      popup = document.querySelector('.mapboxgl-popup-content');
    }
    if (!popup) {
      popup = document.querySelector('.maplibregl-popup');
    }
    if (!popup) return;

    let popupContent = popup.querySelector('#mapster-popup, .map-popup-background, .mapster-popup-shortcode-content, #cpts-popup, .cpts-popup-container');
    if (!popupContent) {
      popupContent = popup;
    }

    // Hide empty info-item sections
    const infoItems = popupContent.querySelectorAll('.info-item');
    infoItems.forEach(item => {
      // Don't hide thematics section
      if (item.classList.contains('thematiques-section')) {
        return;
      }

      const infoValue = item.querySelector('.info-value');
      if (infoValue) {
        const text = infoValue.textContent.trim();
        const html = infoValue.innerHTML.trim();
        const href = infoValue.getAttribute('href');
        
        // Check if placeholder hasn't been replaced (still contains {...})
        const hasUnreplacedPlaceholder = /\{[^}]+\}/.test(text) || /\{[^}]+\}/.test(html);
        
        // If text is empty, contains unreplaced placeholder, or contains only special characters/spaces
        // or if it's a link with empty href or equal to "mailto:" or "http://" or "https://"
        if (hasUnreplacedPlaceholder ||
            !text || 
            text === '' || 
            text === 'false' || 
            text === 'null' || 
            text === 'undefined' ||
            (href && (href === '' || href === 'mailto:' || href === 'http://' || href === 'https://' || /\{[^}]+\}/.test(href)))) {
          item.style.display = 'none';
        } else {
          item.style.display = '';
        }
      }
    });
  }

  // ---------- 12) Hide empty popup titles ----------
  function hideEmptyPopupTitles() {
    let popup = document.querySelector('.maplibregl-popup-content');
    if (!popup) {
      popup = document.querySelector('.mapboxgl-popup-content');
    }
    if (!popup) {
      popup = document.querySelector('.maplibregl-popup');
    }
    if (!popup) return;

    let popupContent = popup.querySelector('#mapster-popup, .map-popup-background, .mapster-popup-shortcode-content');

    if (!popupContent) {
      popupContent = popup;
    }

    const tempHiddenElements = new Map();

    function isEmptyElement(el) {
      if (!el) return true;
      const text = el.textContent?.trim() || '';
      const html = el.innerHTML?.trim() || '';
      return !text || /^[\s\n\r]*$/.test(text) ||
        html === '' || html === '<br>' || html === '<br/>' ||
        html.match(/^<[^>]+>[\s]*<\/[^>]+>$/);
    }

    const allTextElements = popupContent.querySelectorAll('*');
    const labelPatterns = [
      /^site\s+internet$/i,
      /^site\s+web$/i,
      /^téléphone$/i,
      /^tél$/i,
      /^email$/i,
      /^e-mail$/i,
      /^courriel$/i,
      /^adresse$/i,
      /^adresse\s+postale$/i,
      /^ville$/i,
      /^code\s+postal$/i,
      /^cp$/i,
      /^fax$/i,
      /^contact$/i
    ];

    allTextElements.forEach(element => {
      const text = element.textContent?.trim() || '';
      if (!text) return;

      const isExactLabel = labelPatterns.some(pattern => pattern.test(text));

      if (isExactLabel) {
        let hasValue = false;

        const nextSibling = element.nextElementSibling;
        if (nextSibling) {
          const nextText = nextSibling.textContent?.trim() || '';
          if (nextText && nextText.length > 0 && !/^[\s:]*$/.test(nextText)) {
            hasValue = true;
          }
          if (nextSibling.tagName === 'A' && nextSibling.getAttribute('href')) {
            hasValue = true;
          }
        }

        if (!hasValue && element.parentElement) {
          const parent = element.parentElement;
          const parentText = parent.textContent || '';
          const elementText = element.textContent || '';
          const elementIndex = parentText.indexOf(elementText);
          if (elementIndex !== -1) {
            const afterText = parentText.substring(elementIndex + elementText.length).trim();
            if (afterText && afterText.length > 0 && !/^[\s:]*$/.test(afterText)) {
              hasValue = true;
            }
          }
        }

        if (!hasValue && element.parentElement) {
          const parent = element.parentElement;
          const allChildren = Array.from(parent.children);
          const elementIndex = allChildren.indexOf(element);
          for (let i = elementIndex + 1; i < allChildren.length; i++) {
            const nextChild = allChildren[i];
            const childText = nextChild.textContent?.trim() || '';
            if (childText && childText.length > 0 && !/^[\s:]*$/.test(childText)) {
              hasValue = true;
              break;
            }
            if (nextChild.tagName === 'A' && nextChild.getAttribute('href')) {
              hasValue = true;
              break;
            }
          }
        }

        if (!hasValue && element.parentElement && element.parentElement.parentElement) {
          const grandParent = element.parentElement.parentElement;
          const allSiblings = Array.from(grandParent.children);
          const parentIndex = allSiblings.indexOf(element.parentElement);
          for (let i = parentIndex + 1; i < allSiblings.length; i++) {
            const sibling = allSiblings[i];
            const siblingText = sibling.textContent?.trim() || '';
            if (siblingText && siblingText.length > 0 && !/^[\s:]*$/.test(siblingText)) {
              hasValue = true;
              break;
            }
            if (sibling.tagName === 'A' && sibling.getAttribute('href')) {
              hasValue = true;
              break;
            }
          }
        }

        if (!hasValue) {
          const parent = element.parentElement;
          const originalDisplay = element.style.display;
          element.style.display = 'none';
          tempHiddenElements.set(element, originalDisplay);

          if (parent) {
            const parentText = parent.textContent?.trim() || '';
            const elementText = element.textContent?.trim() || '';
            const remainingText = parentText.replace(elementText, '').trim();
            if (remainingText === '' || /^[\s:]*$/.test(remainingText)) {
              const parentOriginalDisplay = parent.style.display;
              parent.style.display = 'none';
              tempHiddenElements.set(parent, parentOriginalDisplay);
            }
            else {
              const allAfter = parentText.substring(parentText.indexOf(elementText) + elementText.length).trim();
              if (!allAfter || /^[\s:]*$/.test(allAfter)) {
                const children = Array.from(parent.children);
                const elementIdx = children.indexOf(element);
                let foundContentAfter = false;
                for (let i = elementIdx + 1; i < children.length; i++) {
                  if (!isEmptyElement(children[i])) {
                    foundContentAfter = true;
                    break;
                  }
                }
                if (foundContentAfter) {
                  element.style.display = originalDisplay || '';
                  tempHiddenElements.delete(element);
                }
              } else {
                element.style.display = originalDisplay || '';
                tempHiddenElements.delete(element);
              }
            }
          }
        } else {
          if (tempHiddenElements.has(element)) {
            element.style.display = tempHiddenElements.get(element) || '';
            tempHiddenElements.delete(element);
          }
        }
      }
    });

  }


  // Popup positioning is now handled entirely by CSS
  // Mapster uses "bottom" anchor, so popup bottom is at click point
  // Tail CSS positioning handles the rest

  const popupObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          if (node.classList?.contains('maplibregl-popup') ||
            node.classList?.contains('mapboxgl-popup') ||
            node.querySelector?.('.maplibregl-popup') ||
            node.querySelector?.('.mapboxgl-popup-content')) {
            
            // Recenter map on click point (popup tip) to ensure popup is fully visible (only once per popup)
            if (window._lastClickLngLat && !window._popupRecentered) {
              const lngLat = window._lastClickLngLat;
              
              // Center the map directly on the click point
              // The popup tip (queue) is at this exact location, so centering here ensures full popup visibility
              map.easeTo({
                center: [lngLat.lng, lngLat.lat],
                duration: 300,
                easing: (t) => t * (2 - t) // ease-out
              });
              
              // Mark as recentered to avoid multiple recenterings
              _popupRecentered = true;
              window._popupRecentered = true;
            }
            
            // Section "Thématiques" is already visible in HTML template, no need to hide it
            hideEmptyPopupSections();
            hideEmptyPopupTitles();
            requestAnimationFrame(() => {
              hideEmptyPopupSections();
              hideEmptyPopupTitles();
            });
            setTimeout(() => {
              hideEmptyPopupSections();
              hideEmptyPopupTitles();
            }, 10);
            setTimeout(() => {
              hideEmptyPopupSections();
              hideEmptyPopupTitles();
            }, 50);
            addCategoriesToPopupDebounced();
          }

          if (node.classList?.contains('maplibregl-popup-content') ||
            node.classList?.contains('mapboxgl-popup-content')) {
            // Section "Thématiques" is already visible in HTML template, no need to hide it
            hideEmptyPopupSections();
            hideEmptyPopupTitles();
            requestAnimationFrame(() => {
              hideEmptyPopupSections();
              hideEmptyPopupTitles();
            });
            addCategoriesToPopupDebounced();
          }
        }
      });
    });
  });

  popupObserver.observe(document.body, { childList: true, subtree: true });

  const popupAttributeObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.target.classList?.contains('maplibregl-popup') ||
        mutation.target.classList?.contains('mapboxgl-popup') ||
        mutation.target.closest?.('.maplibregl-popup') ||
        mutation.target.closest?.('.mapboxgl-popup')) {
        hideEmptyPopupTitles();
        requestAnimationFrame(() => hideEmptyPopupTitles());
        addCategoriesToPopupDebounced();
      }
    });
  });

  popupAttributeObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ['style', 'class'],
    subtree: true
  });

  const popupContentObserver = new MutationObserver((mutations) => {
    // Ignore mutations caused by our own modifications
    let isOurChange = false;
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1 && (
          node.hasAttribute?.('data-category-id') ||
          node.classList?.contains('category-item')
        )) {
          isOurChange = true;
        }
      });
    });

    if (isOurChange) {
      return;
    }

    hideEmptyPopupSections();
    hideEmptyPopupTitles();
    requestAnimationFrame(() => {
      hideEmptyPopupSections();
      hideEmptyPopupTitles();
    });
    addCategoriesToPopupDebounced();
  });

  const initObserver = () => {
    const popupContainer = document.querySelector('.maplibregl-popup-content, .mapboxgl-popup-content');
    if (popupContainer) {
      popupContentObserver.observe(popupContainer, {
        childList: true,
        subtree: true,
        characterData: true
      });
      hideEmptyPopupSections();
      hideEmptyPopupTitles();
      addCategoriesToPopupDebounced();
    }
  };

  initObserver();
  requestAnimationFrame(initObserver);
  setTimeout(initObserver, 10);
  setTimeout(initObserver, 50);
  setTimeout(initObserver, 100);
  
  setTimeout(() => addCategoriesToPopupDebounced(), 50);
  setTimeout(() => addCategoriesToPopupDebounced(), 100);

  // ---------- 13) Inject map header ----------
  function injectMapHeader() {
    // Get header data from WordPress (passed via wp_localize_script)
    const headerData = window.mapHeaderData || {};
    const title = headerData.title || '';
    const pdfUrl = headerData.pdfUrl || '';
    const pdfLabel = headerData.pdfLabel || 'Télécharger le rapport complet';
    
    if (!title && !pdfUrl) {
      return; // No header data, skip
    }

    // Create header element - styles are in SCSS
    const header = document.createElement('div');
    header.className = 'cpts-map-header';
    const container = document.createElement('div');
    container.className = 'container';

    if (title) {
      const h1 = document.createElement('h1');
      h1.textContent = title;
      container.appendChild(h1);
    }

    if (pdfUrl) {
      const link = document.createElement('a');
      link.href = pdfUrl;
      link.className = 'pdf-link';
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" /></svg><span>' + pdfLabel + '</span>';
      container.appendChild(link);
    }

    header.appendChild(container);

    // Insert header before mapster-wp-maps-container
    // This ensures it appears above the map without covering navigation buttons
    const mapContainer = document.querySelector('.mapster-wp-maps-container');
    
    if (mapContainer && mapContainer.parentNode) {
      mapContainer.parentNode.insertBefore(header, mapContainer);
    } else if (!mapContainer) {
      // Wait for map container to be available
      setTimeout(injectMapHeader, 200);
      return;
    } else {
      // Fallback: insert in body if parent not found
      if (document.body) {
        document.body.appendChild(header);
      } else {
        setTimeout(injectMapHeader, 100);
        return;
      }
    }
  }

  // Inject header after map is fully loaded
  function tryInjectHeader() {
    injectMapHeader();
  }
  
  if (map.isStyleLoaded()) {
    setTimeout(tryInjectHeader, 100);
  } else {
    map.once('load', () => {
      setTimeout(tryInjectHeader, 100);
    });
    
    // Fallback: try after a delay
    setTimeout(() => {
      if (!document.querySelector('.cpts-map-header')) {
        tryInjectHeader();
      }
    }, 2000);
  }
  
  // Also listen to style load event
  map.once('styledata', () => {
    setTimeout(tryInjectHeader, 100);
  });
  
  // Final fallback: try after 3 seconds
  setTimeout(() => {
    if (!document.querySelector('.cpts-map-header')) {
      tryInjectHeader();
    }
  }, 3000);
};

// ============================================
// Independent full-page loader
// Created immediately on page load, independent of Mapster structure
// ============================================
(function() {
  'use strict';
  
  // Create loader element immediately
  const createCPTSLoader = function() {
    // Check if loader already exists
    if (document.getElementById('cpts-full-page-loader')) {
      return;
    }
    
    const loader = document.createElement('div');
    loader.id = 'cpts-full-page-loader';
    loader.innerHTML = `
      <div class="cpts-loader-spinner"></div>
    `;
    loader.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background-color: rgba(255, 255, 255, 0.95);
      z-index: 999999;
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 1;
      visibility: visible;
      pointer-events: auto;
      transition: opacity 0.3s ease, visibility 0.3s ease;
    `;
    
    const spinner = loader.querySelector('.cpts-loader-spinner');
    spinner.style.cssText = `
      width: 80px;
      height: 80px;
      border: 5px solid rgba(0, 178, 214, 0.2);
      border-top-color: #00B2D6;
      border-right-color: #002C51;
      border-bottom-color: #D60059;
      border-left-color: #00B2D6;
      border-radius: 50%;
      animation: cpts-loader-spin 1s linear infinite;
    `;
    
    // Add animation if not already present
    if (!document.getElementById('cpts-loader-style')) {
      const style = document.createElement('style');
      style.id = 'cpts-loader-style';
      style.textContent = `
        @keyframes cpts-loader-spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `;
      document.head.appendChild(style);
    }
    
    document.body.appendChild(loader);
    return loader;
  };
  
  // Hide loader function
  const hideCPTSLoader = function() {
    const loader = document.getElementById('cpts-full-page-loader');
    if (loader) {
      loader.style.transition = 'opacity 0.3s ease, visibility 0.3s ease';
      loader.style.opacity = '0';
      loader.style.visibility = 'hidden';
      loader.style.pointerEvents = 'none';
      setTimeout(() => {
        if (loader.parentNode) {
          loader.parentNode.removeChild(loader);
        }
      }, 300);
    }
  };
  
  // Check if we are on a map page
  const isMapPage = function() {
    return document.querySelector('.mapster-wp-maps') !== null;
  };
  
  // Check if map is loaded
  const checkMapLoaded = function() {
    const canvas = document.querySelector('.mapster-wp-maps canvas');
    if (canvas && canvas.offsetWidth > 0 && canvas.offsetHeight > 0) {
      hideCPTSLoader();
      return true;
    }
    return false;
  };
  
  // Create loader only if on map page
  let loaderCreated = false;
  const initLoader = function() {
    // Only create loader if we're on a page with a map
    if (!isMapPage()) {
      return;
    }
    
    if (!loaderCreated) {
      createCPTSLoader();
      loaderCreated = true;
    }
  };
  
  // Check if map page exists before initializing loader
  const checkAndInitLoader = function() {
    if (isMapPage()) {
      initLoader();
    }
  };
  
  if (document.body) {
    checkAndInitLoader();
  } else {
    document.addEventListener('DOMContentLoaded', checkAndInitLoader);
  }
  
  // Also check after a short delay in case map is added dynamically
  setTimeout(checkAndInitLoader, 500);
  
  // Only check for map loading if we're on a map page
  let checkInterval = null;
  let canvasObserver = null;
  
  const startMapLoadingChecks = function() {
    if (!isMapPage()) {
      return;
    }
    
    // Check periodically
    checkInterval = setInterval(() => {
      if (checkMapLoaded()) {
        if (checkInterval) {
          clearInterval(checkInterval);
          checkInterval = null;
        }
      }
    }, 100);
    
    // Stop checking after 10 seconds
    setTimeout(() => {
      if (checkInterval) {
        clearInterval(checkInterval);
        checkInterval = null;
      }
      checkMapLoaded();
    }, 10000);
    
    // Watch for canvas addition
    canvasObserver = new MutationObserver(() => {
      if (checkMapLoaded()) {
        if (canvasObserver) {
          canvasObserver.disconnect();
          canvasObserver = null;
        }
      }
    });
    
    setTimeout(() => {
      if (document.body && canvasObserver) {
        canvasObserver.observe(document.body, {
          childList: true,
          subtree: true
        });
      }
    }, 100);
  };
  
  // Start checks if on map page
  if (isMapPage()) {
    startMapLoadingChecks();
  } else {
    // Check again after DOM is ready
    setTimeout(() => {
      if (isMapPage()) {
        startMapLoadingChecks();
      }
    }, 500);
  }
  
  // Also listen to Mapster events if available
  if (window.mwm) {
    window.mwm.add_action('map_set', (map) => {
      map.on('load', () => {
        setTimeout(hideCPTSLoader, 500);
      });
    });
  }
})();
